/* Copyright (c) 2022 Xperi. All Rights Reserved. */

export class LocaleKeys {
    public static readonly ACTION_PREVIEW_STATUS_MSG_EPISODE_REC =
        'ACTION_PREVIEW_STATUS_MSG_EPISODE_REC';

    public static readonly ACTION_PREVIEW_STATUS_MSG_EXPIRED = 'ACTION_PREVIEW_STATUS_MSG_EXPIRED';

    public static readonly ACTION_PREVIEW_STATUS_MSG_EXPLICITLY_COPY_PROTECTED_DELETE =
        'ACTION_PREVIEW_STATUS_MSG_EXPLICITLY_COPY_PROTECTED_DELETE';

    public static readonly ACTION_PREVIEW_STATUS_MSG_EXPLICITLY_COPY_PROTECTED_WATCH_TIMER =
        'ACTION_PREVIEW_STATUS_MSG_EXPLICITLY_COPY_PROTECTED_WATCH_TIMER';

    public static readonly ACTION_PREVIEW_STATUS_MSG_EXPLICITLY_DELETED =
        'ACTION_PREVIEW_STATUS_MSG_EXPLICITLY_DELETED';

    public static readonly ACTION_PREVIEW_STATUS_MSG_FORCED_DELETION =
        'ACTION_PREVIEW_STATUS_MSG_FORCED_DELETION';

    public static readonly ACTION_PREVIEW_STATUS_MSG_GOING_AWAY_LONG_WEEK =
        'ACTION_PREVIEW_STATUS_MSG_GOING_AWAY_LONG_WEEK';

    public static readonly ACTION_PREVIEW_STATUS_MSG_GOING_AWAY_TODAY =
        'ACTION_PREVIEW_STATUS_MSG_GOING_AWAY_TODAY';

    public static readonly ACTION_PREVIEW_STATUS_MSG_GOING_AWAY_TOMORROW =
        'ACTION_PREVIEW_STATUS_MSG_GOING_AWAY_TOMORROW';

    public static readonly ACTION_PREVIEW_STATUS_MSG_KEEP_AT_MOST_EXCEEDED =
        'ACTION_PREVIEW_STATUS_MSG_KEEP_AT_MOST_EXCEEDED';

    public static readonly ACTION_PREVIEW_STATUS_MSG_KUID = 'ACTION_PREVIEW_STATUS_MSG_KUID';

    public static readonly ACTION_PREVIEW_STATUS_MSG_LOUD_RECORDING =
        'ACTION_PREVIEW_STATUS_MSG_LOUD_RECORDING';

    public static readonly ACTION_PREVIEW_STATUS_MSG_NOT_RECORDABLE =
        'ACTION_PREVIEW_STATUS_MSG_NOT_RECORDABLE';

    public static readonly ACTION_PREVIEW_STATUS_MSG_ONEPASS_EPISODE_RESTRICTION =
        'ACTION_PREVIEW_STATUS_MSG_ONEPASS_EPISODE_RESTRICTION';

    public static readonly ACTION_PREVIEW_STATUS_MSG_ONEPASS_WISHLIST =
        'ACTION_PREVIEW_STATUS_MSG_ONEPASS_WISHLIST';

    public static readonly ACTION_PREVIEW_STATUS_MSG_ONEPASS = 'ACTION_PREVIEW_STATUS_MSG_ONEPASS';

    public static readonly ACTION_PREVIEW_STATUS_MSG_PARTIAL_RECORDING =
        'ACTION_PREVIEW_STATUS_MSG_PARTIAL_RECORDING';

    public static readonly ACTION_PREVIEW_STATUS_MSG_RECORDER_EMERGENCY =
        'ACTION_PREVIEW_STATUS_MSG_RECORDER_EMERGENCY';

    public static readonly ACTION_PREVIEW_STATUS_MSG_RECORDING_NOW =
        'ACTION_PREVIEW_STATUS_MSG_RECORDING_NOW';

    public static readonly ACTION_PREVIEW_STATUS_MSG_SINGLE_EXPLICIT_RECORDING =
        'ACTION_PREVIEW_STATUS_MSG_SINGLE_EXPLICIT_RECORDING';

    public static readonly ALL_EPISODE_DETAIL = 'ALL_EPISODE_DETAIL';

    public static readonly ANTIBURN_OSD_MESSAGE = 'ANTIBURN_OSD_MESSAGE';

    public static readonly AUDIO_LANGUAGE_NOT_PERSISTED_WHISPER_MESSAGE =
        'AUDIO_LANGUAGE_NOT_PERSISTED_WHISPER_MESSAGE';

    public static readonly AUDIO_TRACK_OVERLAY_TITLE = 'AUDIO_TRACK_OVERLAY_TITLE';

    public static readonly BOOKMARK_ALL_WHISPER_MESSAGE_FOR_SEASON_TYPE =
        'BOOKMARK_ALL_WHISPER_MESSAGE_FOR_SEASON_TYPE';

    public static readonly BOOKMARK_ALL_WHISPER_MESSAGE_FOR_YEAR_TYPE =
        'BOOKMARK_ALL_WHISPER_MESSAGE_FOR_YEAR_TYPE';

    public static readonly BOOKMARK_WHISPER_MESSAGE_FOR_EVENT_TYPE =
        'BOOKMARK_WHISPER_MESSAGE_FOR_EVENT_TYPE';

    public static readonly BOOKMARK_WHISPER_MESSAGE_FOR_EPISODE_TYPE =
        'BOOKMARK_WHISPER_MESSAGE_FOR_EPISODE_TYPE';

    public static readonly BOOKMARK_WHISPER_MESSAGE_FOR_GAME_TYPE =
        'BOOKMARK_WHISPER_MESSAGE_FOR_GAME_TYPE';

    public static readonly BOOKMARK_WHISPER_MESSAGE_FOR_MATCH_TYPE =
        'BOOKMARK_WHISPER_MESSAGE_FOR_MATCH_TYPE';

    public static readonly BOOKMARK_WHISPER_MESSAGE_FOR_MOVIE_TYPE =
        'BOOKMARK_WHISPER_MESSAGE_FOR_MOVIE_TYPE';

    public static readonly BOOKMARK_WHISPER_MESSAGE_FOR_RACE_TYPE =
        'BOOKMARK_WHISPER_MESSAGE_FOR_RACE_TYPE';

    public static readonly BOOKMARK_WHISPER_MESSAGE_FOR_SHOW_TYPE =
        'BOOKMARK_WHISPER_MESSAGE_FOR_SHOW_TYPE';

    public static readonly BUTTON_NAME_SELECT_LG = 'BUTTON_NAME_SELECT_LG';

    public static readonly BUTTON_NAME_SELECT_SAMSUNG = 'BUTTON_NAME_SELECT_SAMSUNG';

    public static readonly CANCEL_BECAUSE_DISKCONFLICT_BODY = 'CANCEL_BECAUSE_DISKCONFLICT_BODY';

    public static readonly CANCEL_BECAUSE_DISKCONFLICT_PREVIEW =
        'CANCEL_BECAUSE_DISKCONFLICT_PREVIEW';

    public static readonly CANCEL_BECAUSE_DISKCONFLICT_TITLE = 'CANCEL_BECAUSE_DISKCONFLICT_TITLE';

    public static readonly CANCEL_MAX_RECORDINGS_EXCEEDED_TITLE =
        'CANCEL_MAX_RECORDINGS_EXCEEDED_TITLE';

    public static readonly CANCEL_MAX_RECORDINGS_EXCEEDED_BODY =
        'CANCEL_MAX_RECORDINGS_EXCEEDED_BODY';

    public static readonly CANCEL_MAX_RECORDINGS_EXCEEDED_PREVIEW =
        'CANCEL_MAX_RECORDINGS_EXCEEDED_PREVIEW';

    public static readonly CANCEL_ONEPASS_OVERLAY_DESCRIPTION =
        'CANCEL_ONEPASS_OVERLAY_DESCRIPTION';

    public static readonly CANCEL_ONEPASS_OVERLAY_OPTION_NO = 'CANCEL_ONEPASS_OVERLAY_OPTION_NO';

    public static readonly CANCEL_ONEPASS_OVERLAY_OPTION_YES = 'CANCEL_ONEPASS_OVERLAY_OPTION_YES';

    public static readonly CANCEL_ONEPASS_OVERLAY_TITLE = 'CANCEL_ONEPASS_OVERLAY_TITLE';

    public static readonly CANCEL_RECORDING_OVERLAY_DESCRIPTION =
        'CANCEL_RECORDING_OVERLAY_DESCRIPTION';

    public static readonly CANCEL_RECORDING_OVERLAY_OPTION_NO =
        'CANCEL_RECORDING_OVERLAY_OPTION_NO';

    public static readonly CANCEL_RECORDING_OVERLAY_OPTION_YES =
        'CANCEL_RECORDING_OVERLAY_OPTION_YES';

    public static readonly CANCEL_RECORDING_OVERLAY_TITLE = 'CANCEL_RECORDING_OVERLAY_TITLE';

    public static readonly CAST_DETAIL = 'CAST_DETAIL';

    public static readonly CC_LANGUAGE_NOT_PERSISTED_WHISPER_MESSAGE =
        'CC_LANGUAGE_NOT_PERSISTED_WHISPER_MESSAGE';

    public static readonly CHANNEL_OPTIONS_OVERLAY_NOT_RECORDABLE_MESSAGE =
        'CHANNEL_OPTIONS_OVERLAY_NOT_RECORDABLE_MESSAGE';

    public static readonly CHANNEL_SETTINGS_ERROR_WHISPER_MESSAGE =
        'CHANNEL_SETTINGS_ERROR_WHISPER_MESSAGE';

    public static readonly CHANNEL_SETTINGS_ADD_WHISPER_MESSAGE =
        'CHANNEL_SETTINGS_ADD_WHISPER_MESSAGE';

    public static readonly CHANNEL_SETTINGS_REMOVE_WHISPER_MESSAGE =
        'CHANNEL_SETTINGS_REMOVE_WHISPER_MESSAGE';

    public static readonly CLOUD_DVR_SERVICE_TITLE = 'CLOUD_DVR_SERVICE_TITLE';

    public static readonly COLLECTION_FILTER_LIVE_AND_UPCOMING_TITLE =
        'COLLECTION_FILTER_LIVE_AND_UPCOMING_TITLE';

    public static readonly COLLECTION_FILTER_UPCOMING_EMPTY = 'COLLECTION_FILTER_UPCOMING_EMPTY';

    public static readonly COLLECTION_FILTER_UPCOMING_LEAGUE_TEAM_EMPTY =
        'COLLECTION_FILTER_UPCOMING_LEAGUE_TEAM_EMPTY';

    public static readonly COLLECTION_FILTER_UPCOMING_NONE_TITLE =
        'COLLECTION_FILTER_UPCOMING_NONE_TITLE';

    public static readonly COLLECTION_FILTER_UPCOMING_TITLE = 'COLLECTION_FILTER_UPCOMING_TITLE';

    public static readonly COLLECTION_ITEM_TIP_TEXT_RECORDING =
        'COLLECTION_ITEM_TIP_TEXT_RECORDING';

    public static readonly COLLECTION_ITEM_TIP_TEXT_MORE_INFO =
        'COLLECTION_ITEM_TIP_TEXT_MORE_INFO';

    public static readonly COLLECTION_ITEM_TIP_TEXT_WATCH_ON = 'COLLECTION_ITEM_TIP_TEXT_WATCH_ON';

    public static readonly CREATE_ONEPASS_BOTTOM_TEXT = 'CREATE_ONEPASS_BOTTOM_TEXT';

    public static readonly CREATE_ONEPASS_OVERLAY_TITLE = 'CREATE_ONEPASS_OVERLAY_TITLE';

    public static readonly DELETED_BECAUSE_DISKCONFLICT_BODY = 'DELETED_BECAUSE_DISKCONFLICT_BODY';

    public static readonly DELETED_BECAUSE_DISKCONFLICT_PREVIEW =
        'DELETED_BECAUSE_DISKCONFLICT_PREVIEW';

    public static readonly DELETED_BECAUSE_DISKCONFLICT_TITLE =
        'DELETED_BECAUSE_DISKCONFLICT_TITLE';

    public static readonly DELETE_OVERLAY_BOOKMARK_TITLE = 'DELETE_OVERLAY_BOOKMARK_TITLE';

    public static readonly DELETE_OVERLAY_OPTION_BOOKMARK_CANCEL =
        'DELETE_OVERLAY_OPTION_BOOKMARK_CANCEL';

    public static readonly DELETE_OVERLAY_OPTION_DELETE_NOW = 'DELETE_OVERLAY_OPTION_DELETE_NOW';

    public static readonly DELETE_OVERLAY_OPTION_RECORDING_CANCEL =
        'DELETE_OVERLAY_OPTION_RECORDING_CANCEL';

    public static readonly DELETE_OVERLAY_RECORDING_TITLE = 'DELETE_OVERLAY_RECORDING_TITLE';

    public static readonly DELETE_RECORDING_CONFIRMATION_MESSAGE =
        'DELETE_RECORDING_CONFIRMATION_MESSAGE';

    public static readonly DELETE_RECORDING_OPTION_DELETE = 'DELETE_RECORDING_OPTION_DELETE';

    public static readonly DELETE_RECORDING_OPTION_KEEP_THIS_RECORDING =
        'DELETE_RECORDING_OPTION_KEEP_THIS_RECORDING';

    public static readonly DELETE_RECORDING_OPTION_KEEP = 'DELETE_RECORDING_OPTION_KEEP';

    public static readonly DELETE_RECORDING_TITLE = 'DELETE_RECORDING_TITLE';

    public static readonly DESCRIPTION_NOT_AVAILABLE = 'DESCRIPTION_NOT_AVAILABLE';

    public static readonly EMPTY_GUIDE_NOT_SELECTED_FAVORITE = 'EMPTY_GUIDE_NOT_SELECTED_FAVORITE';

    public static readonly EMPTY_GUIDE_HOW_TO_SELECT_FAVORITE =
        'EMPTY_GUIDE_HOW_TO_SELECT_FAVORITE';

    public static readonly EMPTY_GUIDE_SELECT_DIFFERENT_CHANNEL_LIST =
        'EMPTY_GUIDE_SELECT_DIFFERENT_CHANNEL_LIST';

    public static readonly EMPTY_LIST_TEXT = 'EMPTY_LIST_TEXT';

    public static readonly EMPTY_TILE_MESSAGE_VOD_MAIN_SCREEN =
        'EMPTY_TILE_MESSAGE_VOD_MAIN_SCREEN';

    public static readonly EPISODE = 'EPISODE';

    public static readonly EPISODE_SCREEN_TITLE_ULTIMATE_FALLBACK =
        'EPISODE_SCREEN_TITLE_ULTIMATE_FALLBACK';

    public static readonly EVENT = 'EVENT';

    public static readonly EXTRA = 'EXTRA';

    public static readonly EXPIRED_TITLE = 'EXPIRED_TITLE';

    public static readonly EXPIRED_PREVIEW = 'EXPIRED_PREVIEW';

    public static readonly EXPIRED_BODY = 'EXPIRED_BODY';

    public static readonly EXPLICITLY_DELETED_TITLE = 'EXPLICITLY_DELETED_TITLE';

    public static readonly EXPLICITLY_DELETED_PREVIEW = 'EXPLICITLY_DELETED_PREVIEW';

    public static readonly EXPLICITLY_DELETED_BODY = 'EXPLICITLY_DELETED_BODY';

    public static readonly WRONG_RESOLUTION_BODY = 'WRONG_RESOLUTION_BODY';

    public static readonly WRONG_RESOLUTION_PREVIEW = 'WRONG_RESOLUTION_PREVIEW';

    public static readonly WRONG_RESOLUTION_TITLE = 'WRONG_RESOLUTION_TITLE';

    public static readonly FAILURE_WHISPER_MESSAGE = 'FAILURE_WHISPER_MESSAGE';

    public static readonly FIRST_AIRED = 'FIRST_AIRED';

    public static readonly FIRST_AIRS = 'FIRST_AIRS';

    public static readonly GALLERY_SCREEN_NO_NETWORK_OVERLAY_TITLE =
        'GALLERY_SCREEN_NO_NETWORK_OVERLAY_TITLE';

    public static readonly GALLERY_SCREEN_OVERLAY_ERROR_MESSAGE =
        'GALLERY_SCREEN_OVERLAY_ERROR_MESSAGE';

    public static readonly GALLERY_SCREEN_EMPTY_GRID_MESSAGE = 'GALLERY_SCREEN_EMPTY_GRID_MESSAGE';

    public static readonly GAME = 'GAME';

    public static readonly PRESS_OK_FOR_MORE_INFORMATION = 'PRESS_OK_FOR_MORE_INFORMATION';

    public static readonly GET_THIS_SHOW_DETAILS = 'GET_THIS_SHOW_DETAILS';

    public static readonly GO_TO_NEXT_CHANNEL_TEXT = 'GO_TO_NEXT_CHANNEL_TEXT';

    public static readonly GO_TO_ON_DEMAND_TEXT = 'GO_TO_ON_DEMAND_TEXT';

    public static readonly GO_TO_OVERLAY_TITLE = 'GO_TO_OVERLAY_TITLE';

    public static readonly GUIDE_CHANNEL_OPTIONS_OVERLAY_TITLE =
        'GUIDE_CHANNEL_OPTIONS_OVERLAY_TITLE';

    public static readonly GUIDE_CHANNEL_TYPES_ALL_CHANNELS = 'GUIDE_CHANNEL_TYPES_ALL_CHANNELS';

    public static readonly GUIDE_CHANNEL_TYPES_FAVORITES = 'GUIDE_CHANNEL_TYPES_FAVORITES';

    public static readonly GUIDE_CHANNEL_TYPES_MY_CHANNELS = 'GUIDE_CHANNEL_TYPES_MY_CHANNELS';

    public static readonly GUIDE_DESCRIPTION_HIDDEN = 'GUIDE_DESCRIPTION_HIDDEN';

    public static readonly GUIDE_CATEGORY_TYPES_ALL = 'GUIDE_CATEGORY_TYPES_ALL';

    public static readonly GUIDE_CATEGORY_TYPES_SPORTS = 'GUIDE_CATEGORY_TYPES_SPORTS';

    public static readonly GUIDE_CATEGORY_TYPES_KIDS = 'GUIDE_CATEGORY_TYPES_KIDS';

    public static readonly GUIDE_CATEGORY_TYPES_NEWS = 'GUIDE_CATEGORY_TYPES_NEWS';

    public static readonly GUIDE_CATEGORY_TYPES_MOVIES = 'GUIDE_CATEGORY_TYPES_MOVIES';

    public static readonly GUIDE_EXIT_CONFIRMATION_OVERLAY_DESCRIPTION =
        'GUIDE_EXIT_CONFIRMATION_OVERLAY_DESCRIPTION';

    public static readonly GUIDE_OPTIONS_OVERLAY_TITLE = 'GUIDE_OPTIONS_OVERLAY_TITLE';

    public static readonly GUIDE_OPTIONS_OVERLAY_VIEW = 'GUIDE_OPTIONS_OVERLAY_VIEW';

    public static readonly GUIDE_EXIT_CONFIRMATION_OVERLAY_TITLE =
        'GUIDE_EXIT_CONFIRMATION_OVERLAY_TITLE';

    public static readonly GUIDE_FOOTER_MENU_TEXT = 'GUIDE_FOOTER_MENU_TEXT';

    public static readonly GUIDE_SELECT_OPTIONS_MESSAGE = 'GUIDE_SELECT_OPTIONS_MESSAGE';

    public static readonly GUIDE_SELECT_PRESS_AND_HOLD_MESSAGE =
        'GUIDE_SELECT_PRESS_AND_HOLD_MESSAGE';

    public static readonly GUIDE_SELECT_TO_WATCH_TEXT = 'GUIDE_SELECT_TO_WATCH_TEXT';

    public static readonly GUIDE_SELECTED_CHANNEL_TYPE_ALL_CHANNELS =
        'GUIDE_SELECTED_CHANNEL_TYPE_ALL_CHANNELS';

    public static readonly GUIDE_SELECTED_CHANNEL_TYPE_MY_CHANNELS =
        'GUIDE_SELECTED_CHANNEL_TYPE_MY_CHANNELS';

    public static readonly GUIDE_SETTINGS_MESSAGE_FIRST_PART = 'GUIDE_SETTINGS_MESSAGE_FIRST_PART';

    public static readonly GUIDE_SETTINGS_MESSAGE_MIDDLE_PART =
        'GUIDE_SETTINGS_MESSAGE_MIDDLE_PART';

    public static readonly GUIDE_SETTINGS_MESSAGE_LAST_PART = 'GUIDE_SETTINGS_MESSAGE_LAST_PART';

    public static readonly GUIDE_TEMPORARY_GUIDE_ISSUE_OVERLAY_DESCRIPTION =
        'GUIDE_TEMPORARY_GUIDE_ISSUE_OVERLAY_DESCRIPTION';

    public static readonly GUIDE_TEMPORARY_GUIDE_ISSUE_OVERLAY_TITLE =
        'GUIDE_TEMPORARY_GUIDE_ISSUE_OVERLAY_TITLE';

    public static readonly GUIDE_TITLE_HIDDEN = 'GUIDE_TITLE_HIDDEN';

    public static readonly GUIDE_WHISPER_MESSAGE = 'GUIDE_WHISPER_MESSAGE';

    public static readonly INTERNAL_ERROR_BODY = 'INTERNAL_ERROR_BODY';

    public static readonly INTERNAL_ERROR_PREVIEW = 'INTERNAL_ERROR_PREVIEW';

    public static readonly INTERNAL_ERROR_TITLE = 'INTERNAL_ERROR_TITLE';

    public static readonly JUMP_CHANNEL_OVERLAY_DESCRIPTION = 'JUMP_CHANNEL_OVERLAY_DESCRIPTION';

    public static readonly JUMP_CHANNEL_ERROR_OVERLAY_TITLE = 'JUMP_CHANNEL_ERROR_OVERLAY_TITLE';

    public static readonly JUMP_CHANNEL_ERROR_OVERLAY_DESCRIPTION =
        'JUMP_CHANNEL_ERROR_OVERLAY_DESCRIPTION';

    public static readonly JUMP_TO = 'JUMP_TO';

    // keep until recording overlay
    public static readonly KURO_OPTION_CANCEL = 'KURO_OPTION_CANCEL';

    public static readonly KURO_TITLE = 'KURO_TITLE';

    public static readonly LANGUAGE_NOT_SUPPORTED_OVERLAY_DESCRIPTION =
        'LANGUAGE_NOT_SUPPORTED_OVERLAY_DESCRIPTION';

    public static readonly LANGUAGE_NOT_SUPPORTED_OVERLAY_TITLE =
        'LANGUAGE_NOT_SUPPORTED_OVERLAY_TITLE';

    public static readonly LEAVING_LIVE_TV_TEXT = 'LEAVING_LIVE_TV_TEXT';

    public static readonly LIVE_TV_ACTION_STRIP_BOOKMARK = 'LIVE_TV_ACTION_STRIP_BOOKMARK';

    public static readonly LIVE_TV_ACTION_STRIP_CHANGE_AUDIO_TRACK =
        'LIVE_TV_ACTION_STRIP_CHANGE_AUDIO_TRACK';

    public static readonly LIVE_TV_ACTION_STRIP_CHANGE_SUBTITLES_CC_LANGUAGE =
        'LIVE_TV_ACTION_STRIP_CHANGE_SUBTITLES_CC_LANGUAGE';

    public static readonly LIVE_TV_ACTION_STRIP_CREATE_ONEPASS =
        'LIVE_TV_ACTION_STRIP_CREATE_ONEPASS';

    public static readonly LIVE_TV_ACTION_STRIP_MODIFY_ONEPASS =
        'LIVE_TV_ACTION_STRIP_MODIFY_ONEPASS';

    public static readonly LIVE_TV_ACTION_STRIP_RECORD = 'LIVE_TV_ACTION_STRIP_RECORD';

    public static readonly LIVE_TV_ACTION_STRIP_RESUME = 'LIVE_TV_ACTION_STRIP_RESUME';

    public static readonly LIVE_TV_ACTION_STRIP_SEE_MORE_INFO =
        'LIVE_TV_ACTION_STRIP_SEE_MORE_INFO';

    public static readonly LIVE_TV_ACTION_STRIP_STOP_RECORDING =
        'LIVE_TV_ACTION_STRIP_STOP_RECORDING';

    public static readonly LIVE_TV_ACTION_STRIP_TURN_SUBTITLES_CC_OFF =
        'LIVE_TV_ACTION_STRIP_TURN_SUBTITLES_CC_OFF';

    public static readonly LIVE_TV_ACTION_STRIP_TURN_SUBTITLES_CC_ON =
        'LIVE_TV_ACTION_STRIP_TURN_SUBTITLES_CC_ON';

    public static readonly LIVE_TV_ADULT_OSD_MESSAGE = 'LIVE_TV_ADULT_OSD_MESSAGE';

    public static readonly LIVE_TV_ADVANCE_NOT_ALLOWED = 'LIVE_TV_ADVANCE_NOT_ALLOWED';

    public static readonly LIVE_TV_APP_SESSION_EXPIRED_TITLE = 'LIVE_TV_APP_SESSION_EXPIRED_TITLE';

    public static readonly LIVE_TV_BANNER_TIP_PRESS_AND_HOLD_LIVE_TV_TEXT =
        'LIVE_TV_BANNER_TIP_PRESS_AND_HOLD_LIVE_TV_TEXT';

    public static readonly LIVE_TV_BANNER_TIP_PRESS_AND_HOLD_TO_TEXT =
        'LIVE_TV_BANNER_TIP_PRESS_AND_HOLD_TO_TEXT';

    public static readonly LIVE_TV_BANNER_TIP_WATCH_FROM_BEGINNING_TEXT =
        'LIVE_TV_BANNER_TIP_WATCH_FROM_BEGINNING_TEXT';

    public static readonly LIVE_TV_CANNOT_PLAY_ON_THIS_DEVICE_OSD_MESSAGE =
        'LIVE_TV_CANNOT_PLAY_ON_THIS_DEVICE_OSD_MESSAGE';

    public static readonly LIVE_TV_CANT_PLAY_TITLE = 'LIVE_TV_CANT_PLAY_TITLE';

    public static readonly LIVE_TV_CANT_WATCH_SHOWS_TITLE = 'LIVE_TV_CANT_WATCH_SHOWS_TITLE';

    public static readonly LIVE_TV_CANT_WATCH_NOW_TITLE = 'LIVE_TV_CANT_WATCH_NOW_TITLE';

    public static readonly LIVE_TV_CANT_PLAY_MESSAGE = 'LIVE_TV_CANT_PLAY_MESSAGE';

    public static readonly LIVE_TV_CANT_WATCH_SHOWS_MESSAGE = 'LIVE_TV_CANT_WATCH_SHOWS_MESSAGE';

    public static readonly LIVE_TV_CANT_WATCH_NOW_MESSAGE = 'LIVE_TV_CANT_WATCH_NOW_MESSAGE';

    public static readonly LIVE_TV_CHANGE_AUDIO_TRACK_MESSAGE =
        'LIVE_TV_CHANGE_AUDIO_TRACK_MESSAGE';

    public static readonly LIVE_TV_CHANGE_SUBTITLES_CC_LANGUAGE_MESSAGE =
        'LIVE_TV_CHANGE_SUBTITLES_CC_LANGUAGE_MESSAGE';

    public static readonly LIVE_TV_CHANNEL_NOT_SUBSCRIBED_MESSAGE =
        'LIVE_TV_CHANNEL_NOT_SUBSCRIBED_MESSAGE';

    public static readonly LIVE_TV_CHANNEL_NOT_SUBSCRIBED_FIRST_HALF =
        'LIVE_TV_CHANNEL_NOT_SUBSCRIBED_FIRST_HALF';

    public static readonly LIVE_TV_CHANNEL_NOT_SUBSCRIBED_SECOND_HALF =
        'LIVE_TV_CHANNEL_NOT_SUBSCRIBED_SECOND_HALF';

    public static readonly LIVE_TV_CHANNEL_NOT_SUBSCRIBED_ERROR_CODE =
        'LIVE_TV_CHANNEL_NOT_SUBSCRIBED_ERROR_CODE';

    public static readonly LIVE_TV_DEVICE_CONFIG_ERROR_MESSAGE =
        'LIVE_TV_DEVICE_CONFIG_ERROR_MESSAGE';

    public static readonly LIVE_TV_DEVICE_CONFIG_ERROR_TITLE = 'LIVE_TV_DEVICE_CONFIG_ERROR_TITLE';

    public static readonly LIVE_TV_FAST_FORWARD_NOT_ALLOWED = 'LIVE_TV_FAST_FORWARD_NOT_ALLOWED';

    public static readonly LIVE_TV_INACTIVITY_OSD_MESSAGE = 'LIVE_TV_INACTIVITY_OSD_MESSAGE';

    public static readonly LIVE_TV_IN_BLACKLIST_OSD_MESSAGE = 'LIVE_TV_IN_BLACKLIST_OSD_MESSAGE';

    public static readonly LIVE_TV_MEDIA_BUTTON_ADVANCE = 'LIVE_TV_MEDIA_BUTTON_ADVANCE';

    public static readonly LIVE_TV_MEDIA_BUTTON_FORWARD = 'LIVE_TV_MEDIA_BUTTON_FORWARD';

    public static readonly LIVE_TV_MEDIA_BUTTON_GO_TO_END = 'LIVE_TV_MEDIA_BUTTON_GO_TO_END';

    public static readonly LIVE_TV_MEDIA_BUTTON_GO_TO_LIVE = 'LIVE_TV_MEDIA_BUTTON_GO_TO_LIVE';

    public static readonly LIVE_TV_MEDIA_BUTTON_LIVE = 'LIVE_TV_MEDIA_BUTTON_LIVE';

    public static readonly LIVE_TV_MEDIA_BUTTON_PAUSE = 'LIVE_TV_MEDIA_BUTTON_PAUSE';

    public static readonly LIVE_TV_MEDIA_BUTTON_PLAY = 'LIVE_TV_MEDIA_BUTTON_PLAY';

    public static readonly LIVE_TV_MEDIA_BUTTON_REPLAY = 'LIVE_TV_MEDIA_BUTTON_REPLAY';

    public static readonly LIVE_TV_MEDIA_BUTTON_REWIND = 'LIVE_TV_MEDIA_BUTTON_REWIND';

    public static readonly LIVE_TV_MEDIA_BUTTON_START_FROM_BUFFER =
        'LIVE_TV_MEDIA_BUTTON_START_FROM_BUFFER';

    public static readonly LIVE_TV_MEDIA_BUTTON_START_OVER = 'LIVE_TV_MEDIA_BUTTON_START_OVER';

    public static readonly LIVE_TV_MEDIA_BUTTON_OLG = 'LIVE_TV_MEDIA_BUTTON_OLG';

    public static readonly LIVE_TV_OFF = 'LIVE_TV_OFF';

    public static readonly LIVE_TV_ON = 'LIVE_TV_ON';

    public static readonly LIVE_TV_OOH_OSD_MESSAGE = 'LIVE_TV_OOH_OSD_MESSAGE';

    public static readonly LIVE_TV_OUT_OF_REGION_OSD_MESSAGE = 'LIVE_TV_OUT_OF_REGION_OSD_MESSAGE';

    public static readonly LIVE_TV_OSD_PC_ADULT_LOCKED_MESSAGE =
        'LIVE_TV_OSD_PC_ADULT_LOCKED_MESSAGE';

    public static readonly LIVE_TV_OSD_PC_LOCKED_RATING_MESSAGE =
        'LIVE_TV_OSD_PC_LOCKED_RATING_MESSAGE';

    public static readonly LIVE_TV_OSD_PC_RATING_UNKNOWN_MESSAGE =
        'LIVE_TV_OSD_PC_RATING_UNKNOWN_MESSAGE';

    public static readonly LIVE_TV_LOCATION_RESTRICTION_OSD_MESSAGE =
        'LIVE_TV_LOCATION_RESTRICTION_OSD_MESSAGE';

    public static readonly LIVE_TV_PAUSE_NOT_SUPPORTED_MESSAGE =
        'LIVE_TV_PAUSE_NOT_SUPPORTED_MESSAGE';

    public static readonly LIVE_TV_PLAYER_ENFORCEMENT_ERROR_MESSAGE =
        'LIVE_TV_PLAYER_ENFORCEMENT_ERROR_MESSAGE';

    public static readonly LIVE_TV_PLAYER_ENFORCEMENT_ERROR_TITLE =
        'LIVE_TV_PLAYER_ENFORCEMENT_ERROR_TITLE';

    public static readonly LIVE_TV_PLAYER_ERROR_TITLE = 'LIVE_TV_PLAYER_ERROR_TITLE';

    public static readonly LIVE_TV_REWIND_NOT_ALLOWED = 'LIVE_TV_REWIND_NOT_ALLOWED';

    public static readonly LIVE_TV_REPLAY_NOT_ALLOWED = 'LIVE_TV_REPLAY_NOT_ALLOWED';

    public static readonly LIVE_TV_SPINNER_GETTING_YOUR_SHOW = 'LIVE_TV_SPINNER_GETTING_YOUR_SHOW';

    public static readonly LIVE_TV_SPINNER_GOING_TO_LIVE_TV = 'LIVE_TV_SPINNER_GOING_TO_LIVE_TV';

    public static readonly LIVE_TV_SPINNER_LOADING_VIDEO = 'LIVE_TV_SPINNER_LOADING_VIDEO';

    public static readonly LIVE_TV_STANDARD_INFO_BANNER_UP_NEXT =
        'LIVE_TV_STANDARD_INFO_BANNER_UP_NEXT';

    public static readonly LIVE_TV_STANDARD_INFO_BANNER_LIVE_TV_STRING =
        'LIVE_TV_STANDARD_INFO_BANNER_LIVE_TV_STRING';

    public static readonly LIVE_TV_STANDARD_INFO_BANNER_RECORDING_STRING =
        'LIVE_TV_STANDARD_INFO_BANNER_RECORDING_STRING';

    public static readonly LIVE_TV_TURN_SUBTITLES_CC_ON_MESSAGE =
        'LIVE_TV_TURN_SUBTITLES_CC_ON_MESSAGE';

    public static readonly LIVE_TV_SUBSCRIPTION_REQUIRED_TITLE =
        'LIVE_TV_SUBSCRIPTION_REQUIRED_TITLE';

    public static readonly LIVE_TV_APP_SESSION_EXPIRED_MESSAGE =
        'LIVE_TV_APP_SESSION_EXPIRED_MESSAGE';

    public static readonly LIVE_TV_SUBSCRIPTION_REQUIRED_MESSAGE =
        'LIVE_TV_SUBSCRIPTION_REQUIRED_MESSAGE';

    public static readonly LIVE_TV_SOMETHING_WENT_WRONG_MESSAGE =
        'LIVE_TV_SOMETHING_WENT_WRONG_MESSAGE';

    public static readonly LIVE_TV_SOMETHING_WENT_WRONG_TITLE =
        'LIVE_TV_SOMETHING_WENT_WRONG_TITLE';

    public static readonly LIVE_TV_GRACE_PERIOD_ENDED_ERROR_TITLE =
        'LIVE_TV_GRACE_PERIOD_ENDED_ERROR_TITLE';

    public static readonly LIVE_TV_GRACE_PERIOD_ENDED_ERROR_MESSAGE =
        'LIVE_TV_GRACE_PERIOD_ENDED_ERROR_MESSAGE';

    public static readonly LIVE_TV_TOO_MANY_STREAMS_FOR_RESOURCE_MESSAGE =
        'LIVE_TV_TOO_MANY_STREAMS_FOR_RESOURCE_MESSAGE';

    public static readonly LIVE_TV_NO_SESSION_MESSAGE = 'LIVE_TV_NO_SESSION_MESSAGE';

    public static readonly LIVE_TV_UNABLE_TO_PLAY_MESSAGE = 'LIVE_TV_UNABLE_TO_PLAY_MESSAGE';

    public static readonly LIVE_TV_UNSUPPORTED_CONTENT_ERROR_MESSAGE =
        'LIVE_TV_UNSUPPORTED_CONTENT_ERROR_MESSAGE';

    // List View Screen

    public static readonly LIST_VIEW_SCREEN_WHISPER_MESSAGE = 'LIST_VIEW_SCREEN_WHISPER_MESSAGE';

    public static readonly LIST_VIEW_SCREEN_ERROR_MESSAGE = 'LIST_VIEW_SCREEN_ERROR_MESSAGE';

    public static readonly MATCH = 'MATCH';

    public static readonly MOVIE = 'MOVIE';

    public static readonly MAX_RECORDINGS_NOW_SHOWING_TITLE = 'MAX_RECORDINGS_NOW_SHOWING_TITLE';

    public static readonly MAX_RECORDINGS_NOW_SHOWING_BODY = 'MAX_RECORDINGS_NOW_SHOWING_BODY';

    public static readonly MAX_RECORDINGS_NOW_SHOWING_PREVIEW =
        'MAX_RECORDINGS_NOW_SHOWING_PREVIEW';

    public static readonly MAY_ALSO_LIKE_DETAIL = 'MAY_ALSO_LIKE_DETAIL';

    public static readonly MODIFY_ONEPASS_OVERLAY_TITLE = 'MODIFY_ONEPASS_OVERLAY_TITLE';

    public static readonly MODIFY_RECORDING_WHISPER_MESSAGE = 'MODIFY_RECORDING_WHISPER_MESSAGE';

    public static readonly MORE_INFO_DETAIL = 'MORE_INFO_DETAIL';

    public static readonly MY_SHOWS_ERROR_MESSAGE = 'MY_SHOWS_ERROR_MESSAGE';

    public static readonly MY_SHOWS_FILTER_ERROR_MESSAGE = 'MY_SHOWS_FILTER_ERROR_MESSAGE';

    public static readonly MY_SHOWS_TRANSITION_ERROR_MESSAGE = 'MY_SHOWS_TRANSITION_ERROR_MESSAGE';

    public static readonly MY_SHOWS_HEADER_TITLE = 'MY_SHOWS_HEADER_TITLE';

    public static readonly MY_SHOWS_RECORDINGS = 'MY_SHOWS_RECORDINGS';

    public static readonly MY_SHOWS_ALL_SHOWS = 'MY_SHOWS_ALL_SHOWS';

    public static readonly MY_SHOWS_MOVIES = 'MY_SHOWS_MOVIES';

    public static readonly MY_SHOWS_TV_SERIES = 'MY_SHOWS_TV_SERIES';

    public static readonly MY_SHOWS_KIDS = 'MY_SHOWS_KIDS';

    public static readonly MY_SHOWS_SPORTS = 'MY_SHOWS_SPORTS';

    public static readonly MY_SHOWS_PAUSED = 'MY_SHOWS_PAUSED';

    public static readonly MY_SHOWS_DEFAULT = 'MY_SHOWS_DEFAULT';

    public static readonly NDVR_SESSION_ERROR_NOT_AUTHORIZED_MESSAGE =
        'NDVR_SESSION_ERROR_NOT_AUTHORIZED_MESSAGE';

    public static readonly NONE = 'NONE';

    public static readonly NO_NETWORK_OVERLAY_DESCRIPTION = 'NO_NETWORK_OVERLAY_DESCRIPTION';

    public static readonly NO_NETWORK_OVERLAY_TITLE = 'NO_NETWORK_OVERLAY_TITLE';

    public static readonly NO_NETWORK_WHISPER_DESCRIPTION = 'NO_NETWORK_WHISPER_DESCRIPTION';

    public static readonly NOT_AVAILABLE = 'NOT_AVAILABLE';

    public static readonly ONEPASS_DELETED_WHISPER_MESSAGE = 'ONEPASS_DELETED_WHISPER_MESSAGE';

    public static readonly ONEPASS_ERROR_WHISPER_MESSAGE = 'ONEPASS_ERROR_WHISPER_MESSAGE';

    public static readonly ONEPASS_MANAGER_EMPTY_LIST_MESSAGE =
        'ONEPASS_MANAGER_EMPTY_LIST_MESSAGE';

    public static readonly ONEPASS_MANAGER_TITLE = 'ONEPASS_MANAGER_TITLE';

    public static readonly SETTINGS_MANAGE = 'SETTINGS_MANAGE';

    public static readonly SETTINGS_MANAGE_TITLE = 'SETTINGS_MANAGE_TITLE';

    public static readonly SETTINGS_MANAGE_PREVIEW_TEXT = 'SETTINGS_MANAGE_PREVIEW_TEXT';

    public static readonly ONEPASS_MODIFIED_WHISPER_MESSAGE = 'ONEPASS_MODIFIED_WHISPER_MESSAGE';

    public static readonly ONEPASS_OPTIONS_DETAIL = 'ONEPASS_OPTIONS_DETAIL';

    public static readonly ONEPASS_SCHEDULED_WHISPER_MESSAGE = 'ONEPASS_SCHEDULED_WHISPER_MESSAGE';

    public static readonly ON_DEMAND_EPISODES_UNIFIED_COLLECTION_DETAIL =
        'ON_DEMAND_EPISODES_UNIFIED_COLLECTION_DETAIL';

    public static readonly ON_DEMAND_TITLE = 'ON_DEMAND_TITLE';

    public static readonly OPO_CANCEL_DONT_SAVE_ONEPASS = 'OPO_CANCEL_DONT_SAVE_ONEPASS';

    public static readonly OPO_CANCEL_THIS_ONEPASS = 'OPO_CANCEL_THIS_ONEPASS';

    public static readonly OPO_CREATE_ONEPASS_WITH_THESE_OPTIONS =
        'OPO_CREATE_ONEPASS_WITH_THESE_OPTIONS';

    public static readonly OPO_DONT_CHANGE_OPTIONS = 'OPO_DONT_CHANGE_OPTIONS';

    public static readonly OPO_OPTION_CHANNEL = 'OPO_OPTION_CHANNEL';

    public static readonly OPO_OPTION_DISPLAY_OPTIONS = 'OPO_OPTION_DISPLAY_OPTIONS';

    public static readonly OPO_OPTION_INCLUDE_TYPE = 'OPO_OPTION_INCLUDE_TYPE';

    public static readonly OPO_OPTION_KEEP_AT_MOST = 'OPO_OPTION_KEEP_AT_MOST';

    public static readonly OPO_OPTION_KEEP_UNTIL = 'OPO_OPTION_KEEP_UNTIL';

    public static readonly OPO_OPTION_RECORD_TYPE = 'OPO_OPTION_RECORD_TYPE';

    public static readonly OPO_OPTION_RENT_OR_BUY = 'OPO_OPTION_RENT_OR_BUY';

    public static readonly OPO_OPTION_START_FROM = 'OPO_OPTION_START_FROM';

    public static readonly OPO_OPTION_START_RECORDING = 'OPO_OPTION_START_RECORDING';

    public static readonly OPO_OPTION_STOP_RECORDING = 'OPO_OPTION_STOP_RECORDING';

    public static readonly OPO_OPTION_VIDEO_QUALITY = 'OPO_OPTION_VIDEO_QUALITY';

    public static readonly OPO_OPTION_DISPLAY_OPTIONS_PREVIEW =
        'OPO_OPTION_DISPLAY_OPTIONS_PREVIEW';

    public static readonly OPO_OPTION_INCLUDE_TYPE_PREVIEW = 'OPO_OPTION_INCLUDE_TYPE_PREVIEW';

    public static readonly OPO_OPTION_KEEP_AT_MOST_PREVIEW = 'OPO_OPTION_KEEP_AT_MOST_PREVIEW';

    public static readonly OPO_OPTION_KEEP_UNTIL_PREVIEW = 'OPO_OPTION_KEEP_UNTIL_PREVIEW';

    public static readonly OPO_OPTION_KEEP_UNTIL_PREVIEW_NOTE =
        'OPO_OPTION_KEEP_UNTIL_PREVIEW_NOTE';

    public static readonly OPO_OPTION_RECORD_TYPE_PREVIEW = 'OPO_OPTION_RECORD_TYPE_PREVIEW';

    public static readonly OPO_OPTION_RENT_OR_BUY_PREVIEW = 'OPO_OPTION_RENT_OR_BUY_PREVIEW';

    public static readonly OPO_OPTION_START_FROM_PREVIEW = 'OPO_OPTION_START_FROM_PREVIEW';

    public static readonly OPO_OPTION_START_RECORDING_PREVIEW =
        'OPO_OPTION_START_RECORDING_PREVIEW';

    public static readonly OPO_OPTION_STOP_RECORDING_PREVIEW = 'OPO_OPTION_STOP_RECORDING_PREVIEW';

    public static readonly OPO_OPTION_START_STOP_RECORDING_PREVIEW_NOTE =
        'OPO_OPTION_START_STOP_RECORDING_PREVIEW_NOTE';

    public static readonly OPO_OPTION_VIDEO_QUALITY_PREVIEW = 'OPO_OPTION_VIDEO_QUALITY_PREVIEW';

    public static readonly OPO_OVERLAY_TITLE = 'OPO_OVERLAY_TITLE';

    public static readonly OVERLAY_BUTTON_GO_BACK = 'OVERLAY_BUTTON_GO_BACK';

    public static readonly OPO_USE_THESE_OPTIONS = 'OPO_USE_THESE_OPTIONS';

    public static readonly OVERLAY_OPTION_CANCEL_TEXT = 'OVERLAY_OPTION_CANCEL_TEXT';

    public static readonly OVERLAY_OPTION_EXIT_TEXT = 'OVERLAY_OPTION_EXIT_TEXT';

    public static readonly OVERLAY_OPTION_GO_TO_SETTINGS = 'OVERLAY_OPTION_GO_TO_SETTINGS';

    public static readonly OVERLAY_OPTION_OK_TEXT = 'OVERLAY_OPTION_OK_TEXT';

    public static readonly OVERLAY_OPTION_RESUME_PLAYING_TEXT =
        'OVERLAY_OPTION_RESUME_PLAYING_TEXT';

    public static readonly OVERLAY_OPTION_START_OVER_FROM_BEGINNING_TEXT =
        'OVERLAY_OPTION_START_OVER_FROM_BEGINNING_TEXT';

    public static readonly OVERLAY_OPTION_TRY_AGAIN_TEXT = 'OVERLAY_OPTION_TRY_AGAIN_TEXT';

    public static readonly OVERLAY_OPTIONS_ADD_FAVORITE_CHANNELS_TEXT =
        'OVERLAY_OPTIONS_ADD_FAVORITE_CHANNELS_TEXT';

    public static readonly OVERLAY_OPTIONS_VIEW_GUIDE_WITH_THESE_OPTIONS =
        'OVERLAY_OPTIONS_VIEW_GUIDE_WITH_THESE_OPTIONS';

    public static readonly OVERLAY_OPTIONS_CHANNELS_TEXT = 'OVERLAY_OPTIONS_CHANNELS_TEXT';

    public static readonly OVERLAY_OPTIONS_CATEGORIES_TEXT = 'OVERLAY_OPTIONS_CATEGORIES_TEXT';

    public static readonly OVERLAY_OPTIONS_GO_TO_GUIDE_TEXT = 'OVERLAY_OPTIONS_GO_TO_GUIDE_TEXT';

    public static readonly OVERLAY_OPTIONS_REMOVE_FAVORITE_CHANNELS_TEXT =
        'OVERLAY_OPTIONS_REMOVE_FAVORITE_CHANNELS_TEXT';

    public static readonly OVERLAY_OPTIONS_SEE_CHANNEL_OPTIONS_TEXT =
        'OVERLAY_OPTIONS_SEE_CHANNEL_OPTIONS_TEXT';

    public static readonly OVERLAY_OPTIONS_WATCH_LIVE_TEXT = 'OVERLAY_OPTIONS_WATCH_LIVE_TEXT';

    public static readonly OVERLAY_OPTIONS_WATCH_NOW_FROM_TEXT =
        'OVERLAY_OPTIONS_WATCH_NOW_FROM_TEXT';

    public static readonly OVERLAY_OPTIONS_WATCH_NOW_TEXT = 'OVERLAY_OPTIONS_WATCH_NOW_TEXT';

    public static readonly PC_CANNOT_COMPLETE_REQUEST_OVERLAY_DESCRIPTION =
        'PC_CANNOT_COMPLETE_REQUEST_OVERLAY_DESCRIPTION';

    public static readonly PC_CANNOT_COMPLETE_REQUEST_OVERLAY_TITLE =
        'PC_CANNOT_COMPLETE_REQUEST_OVERLAY_TITLE';

    public static readonly PC_CONFIRM_NEW_PIN_OVERLAY_DESCRIPTION =
        'PC_CONFIRM_NEW_PIN_OVERLAY_DESCRIPTION';

    public static readonly PC_CONFIRM_PIN_OVERLAY_DESCRIPTION =
        'PC_CONFIRM_PIN_OVERLAY_DESCRIPTION';

    public static readonly PC_CONFIRM_PIN_OVERLAY_TITLE = 'PC_CONFIRM_PIN_OVERLAY_TITLE';

    public static readonly PC_CREATE_PIN_OVERLAY_DESCRIPTION = 'PC_CREATE_PIN_OVERLAY_DESCRIPTION';

    public static readonly PC_CREATE_PIN_OVERLAY_TITLE = 'PC_CREATE_PIN_OVERLAY_TITLE';

    public static readonly PC_CURRENT_PIN_OVERLAY_DESCRIPTION =
        'PC_CURRENT_PIN_OVERLAY_DESCRIPTION';

    public static readonly PC_CURRENT_PIN_OVERLAY_TITLE = 'PC_CURRENT_PIN_OVERLAY_TITLE';

    public static readonly PC_DISABLE_PARENTAL_CONTROLS_OVERLAY_DESCRIPTION =
        'PC_DISABLE_PARENTAL_CONTROLS_OVERLAY_DESCRIPTION';

    public static readonly PC_ENTER_PIN_ON_LOCKED_OVERLAY_DESCRIPTION =
        'PC_ENTER_PIN_ON_LOCKED_OVERLAY_DESCRIPTION';

    public static readonly PC_ENTER_PIN_RAING_OVERLAY_DESCRIPTION =
        'PC_ENTER_PIN_RAING_OVERLAY_DESCRIPTION';

    public static readonly PC_ENTER_PIN_RATING_ADULT_OVERLAY_DESCRIPTION =
        'PC_ENTER_PIN_RATING_ADULT_OVERLAY_DESCRIPTION';

    public static readonly PC_ENTER_PIN_RATING_ADULT_OVERLAY_GUIDE_DESCRIPTION =
        'PC_ENTER_PIN_RATING_ADULT_OVERLAY_GUIDE_DESCRIPTION';

    public static readonly PC_ENTER_PIN_RATING_OVERLAY_GUIDE_DESCRIPTION =
        'PC_ENTER_PIN_RATING_OVERLAY_GUIDE_DESCRIPTION';

    public static readonly PC_ENTER_PIN_UNKNOWN_RATING_OVERLAY_DESCRIPTION =
        'PC_ENTER_PIN_UNKNOWN_RATING_OVERLAY_DESCRIPTION';

    public static readonly PC_ENTER_PIN_UNKNOWN_RATING_OVERLAY_GUIDE_DESCRIPTION =
        'PC_ENTER_PIN_UNKNOWN_RATING_OVERLAY_GUIDE_DESCRIPTION';

    public static readonly PC_ENTER_PIN_OVERLAY_DESCRIPTION = 'PC_ENTER_PIN_OVERLAY_DESCRIPTION';

    public static readonly PC_ENTER_PIN_OVERLAY_TITLE = 'PC_ENTER_PIN_OVERLAY_TITLE';

    public static readonly PC_HELP_SCREEN_TURN_ON_OFF_PREVIEW_TEXT =
        'PC_HELP_SCREEN_TURN_ON_OFF_PREVIEW_TEXT';

    public static readonly PC_HELP_SCREEN_TURN_ON_OFF_TITLE = 'PC_HELP_SCREEN_TURN_ON_OFF_TITLE';

    public static readonly PC_HELP_SCREEN_SETTINGS_OPTION = 'PC_HELP_SCREEN_SETTINGS_OPTION';

    public static readonly PC_HELP_SCREEN_SETTINGS_OPTION_PREVIEW_TEXT =
        'PC_HELP_SCREEN_SETTINGS_OPTION_PREVIEW_TEXT';

    public static readonly PC_HELP_SCREEN_SETTINGS_TITLE = 'PC_HELP_SCREEN_SETTINGS_TITLE';

    public static readonly PC_HELP_SCREEN_FORGOTTEN_TITLE = 'PC_HELP_SCREEN_FORGOTTEN_TITLE';

    public static readonly PC_NEW_PIN_OVERLAY_DESCRIPTION = 'PC_NEW_PIN_OVERLAY_DESCRIPTION';

    public static readonly PC_NEW_PIN_OVERLAY_TITLE = 'PC_NEW_PIN_OVERLAY_TITLE';

    public static readonly PC_INCORRECT_PIN_OVERLAY_DESCRIPTION =
        'PC_INCORRECT_PIN_OVERLAY_DESCRIPTION';

    public static readonly PC_INCORRECT_PIN_OVERLAY_TITLE = 'PC_INCORRECT_PIN_OVERLAY_TITLE';

    public static readonly PC_NEW_PIN_NOT_MATCHED_DESCRIPTION =
        'PC_NEW_PIN_NOT_MATCHED_DESCRIPTION';

    public static readonly PC_TEMPORARY_PROBLEM_OVERLAY_DESCRIPTION =
        'PC_TEMPORARY_PROBLEM_OVERLAY_DESCRIPTION';

    public static readonly PC_TEMPORARY_PROBLEM_OVERLAY_TITLE =
        'PC_TEMPORARY_PROBLEM_OVERLAY_TITLE';

    public static readonly PLAYBACK_NOT_SUPPORTED_WHISPER_MESSAGE =
        'PLAYBACK_NOT_SUPPORTED_WHISPER_MESSAGE';

    public static readonly PROGRAM = 'PROGRAM';

    public static readonly PREVIEW_HIDDEN_DESCRIPTION = 'PREVIEW_HIDDEN_DESCRIPTION';

    // PROGRAM SCREEN
    public static readonly PS_EMPTY_TILE_DESCRIPTION = 'PS_EMPTY_TILE_DESCRIPTION';

    public static readonly PS_OPTION_ADD_SEASON_STREAMING_VIDEO =
        'PS_OPTION_ADD_SEASON_STREAMING_VIDEO';

    public static readonly PS_OPTION_ADD_YEAR_STREAMING_VIDEO =
        'PS_OPTION_ADD_YEAR_STREAMING_VIDEO';

    public static readonly PS_OPTION_UNKNOWN = 'PS_OPTION_UNKNOWN';

    public static readonly PS_OPTION_UNKNOWN_DETAIL = 'PS_OPTION_UNKNOWN_DETAIL';

    public static readonly PS_OPTION_BOOKMARK_THIS_EPISODE = 'PS_OPTION_BOOKMARK_THIS_EPISODE';

    public static readonly PS_OPTION_BOOKMARK_THIS_EVENT = 'PS_OPTION_BOOKMARK_THIS_EVENT';

    public static readonly PS_OPTION_BOOKMARK_THIS_GAME = 'PS_OPTION_BOOKMARK_THIS_GAME';

    public static readonly PS_OPTION_BOOKMARK_THIS_MATCH = 'PS_OPTION_BOOKMARK_THIS_MATCH';

    public static readonly PS_OPTION_BOOKMARK_THIS_MOVIE = 'PS_OPTION_BOOKMARK_THIS_MOVIE';

    public static readonly PS_OPTION_BOOKMARK_THIS_RACE = 'PS_OPTION_BOOKMARK_THIS_RACE';

    public static readonly PS_OPTION_BOOKMARK_THIS_SHOW = 'PS_OPTION_BOOKMARK_THIS_SHOW';

    public static readonly PS_OPTION_CANCEL_MULTI_ONEPASS = 'PS_OPTION_CANCEL_MULTI_ONEPASS';

    public static readonly PS_OPTION_CANCEL_ONEPASS_V2 = 'PS_OPTION_CANCEL_ONEPASS_V2';

    public static readonly PS_OPTION_CANCEL_RECORDING = 'PS_OPTION_CANCEL_RECORDING';

    public static readonly PS_OPTION_CAST_DETAIL = 'PS_OPTION_CAST_DETAIL';

    public static readonly PS_OPTION_CREATE_MULTI_ONEPASS = 'PS_OPTION_CREATE_MULTI_ONEPASS';

    public static readonly PS_OPTION_CREATE_ONEPASS_V2 = 'PS_OPTION_CREATE_ONEPASS_V2';

    public static readonly PS_OPTION_DEFAULT_DELETE_RECORDING =
        'PS_OPTION_DEFAULT_DELETE_RECORDING';

    public static readonly PS_OPTION_DELETE_BOOKMARK = 'PS_OPTION_DELETE_BOOKMARK';

    public static readonly PS_OPTION_DELETE_RECORDING = 'PS_OPTION_DELETE_RECORDING';

    public static readonly PS_OPTION_GET_THIS_SHOW_DETAIL = 'PS_OPTION_GET_THIS_SHOW_DETAIL';

    public static readonly PS_OPTION_INFO = 'PS_OPTION_INFO';

    public static readonly PS_OPTION_INFO_DETAIL = 'PS_OPTION_INFO_DETAIL';

    public static readonly PS_OPTION_CAN_RECORD_GET_THIS_SHOW_DETAIL_EPISODE =
        'PS_OPTION_CAN_RECORD_GET_THIS_SHOW_DETAIL_EPISODE';

    public static readonly PS_OPTION_GET_THIS_SHOW_DETAIL_EPISODE =
        'PS_OPTION_GET_THIS_SHOW_DETAIL_EPISODE';

    public static readonly PS_OPTION_CAN_RECORD_GET_THIS_SHOW_DETAIL_MOVIE =
        'PS_OPTION_CAN_RECORD_GET_THIS_SHOW_DETAIL_MOVIE';

    public static readonly PS_OPTION_GET_THIS_SHOW_DETAIL_MOVIE =
        'PS_OPTION_GET_THIS_SHOW_DETAIL_MOVIE';

    public static readonly PS_OPTION_CAN_RECORD_GET_THIS_SHOW_DETAIL_PROGRAM =
        'PS_OPTION_CAN_RECORD_GET_THIS_SHOW_DETAIL_PROGRAM';

    public static readonly PS_OPTION_GET_THIS_SHOW_DETAIL_PROGRAM =
        'PS_OPTION_GET_THIS_SHOW_DETAIL_PROGRAM';

    public static readonly PS_OPTION_MAY_ALSO_LIKE_DETAIL = 'PS_OPTION_MAY_ALSO_LIKE_DETAIL';

    public static readonly PS_OPTION_MODIFY_KEEP_UNTIL = 'PS_OPTION_MODIFY_KEEP_UNTIL';

    public static readonly PS_OPTION_MODIFY_MULTI_ONEPASS = 'PS_OPTION_MODIFY_MULTI_ONEPASS';

    public static readonly PS_OPTION_MODIFY_ONEPASS_V2 = 'PS_OPTION_MODIFY_ONEPASS_V2';

    public static readonly PS_OPTION_MODIFY_RECORDING = 'PS_OPTION_MODIFY_RECORDING';

    public static readonly PS_OPTION_MORE_INFO_DETAIL = 'PS_OPTION_MORE_INFO_DETAIL';

    public static readonly PS_OPTION_ON_DEMAND_EPISODES_DETAIL =
        'PS_OPTION_ON_DEMAND_EPISODES_DETAIL';

    public static readonly PS_OPTION_ONE_PASS_OPTIONS_DETAIL = 'PS_OPTION_ONE_PASS_OPTIONS_DETAIL';

    public static readonly PS_OPTION_RECORD_AGAIN = 'PS_OPTION_RECORD_AGAIN';

    public static readonly PS_OPTION_RECORDING_OPTIONS_DETAIL =
        'PS_OPTION_RECORDING_OPTIONS_DETAIL';

    public static readonly PS_OPTION_RECORD_THIS_EPISODE = 'PS_OPTION_RECORD_THIS_EPISODE';

    public static readonly PS_OPTION_RECORD_THIS_EVENT = 'PS_OPTION_RECORD_THIS_EVENT';

    public static readonly PS_OPTION_RECORD_THIS_GAME = 'PS_OPTION_RECORD_THIS_GAME';

    public static readonly PS_OPTION_RECORD_THIS_MATCH = 'PS_OPTION_RECORD_THIS_MATCH';

    public static readonly PS_OPTION_RECORD_THIS_MOVIE = 'PS_OPTION_RECORD_THIS_MOVIE';

    public static readonly PS_OPTION_RECORD_THIS_RACE = 'PS_OPTION_RECORD_THIS_RACE';

    public static readonly PS_OPTION_RECORD_THIS_SHOW = 'PS_OPTION_RECORD_THIS_SHOW';

    public static readonly PS_OPTION_RECOVER_RECORDING = 'PS_OPTION_RECOVER_RECORDING';

    public static readonly PS_OPTION_RECOVER_RECORDING_DETAIL =
        'PS_OPTION_RECOVER_RECORDING_DETAIL';

    public static readonly PS_OPTION_START_OVER = 'PS_OPTION_START_OVER';

    public static readonly PS_OPTION_SEASON_OR_YEAR_DETAIL = 'PS_OPTION_SEASON_OR_YEAR_DETAIL';

    public static readonly PS_OPTION_STREAMING_OPTIONS = 'PS_OPTION_STREAMING_OPTIONS';

    public static readonly PS_OPTION_UPCOMING_AIRING_DETAIL = 'PS_OPTION_UPCOMING_AIRING_DETAIL';

    public static readonly PS_OPTION_UPCOMING_EPISODES_DETAIL =
        'PS_OPTION_UPCOMING_EPISODES_DETAIL';

    public static readonly PS_OPTION_UPCOMING_EPISODES_DETAIL_EPISODE =
        'PS_OPTION_UPCOMING_EPISODES_DETAIL_EPISODE';

    public static readonly PS_OPTION_UPCOMING_EPISODES_DETAIL_GAME =
        'PS_OPTION_UPCOMING_EPISODES_DETAIL_GAME';

    public static readonly PS_OPTION_WATCH_NOW_DETAIL = 'PS_OPTION_WATCH_NOW_DETAIL';

    public static readonly PS_OPTION_WATCH_PREVIEW_DETAIL = 'PS_OPTION_WATCH_PREVIEW_DETAIL';

    public static readonly PS_OPTION_STOP_AND_DELETE_RECORDING =
        'PS_OPTION_STOP_AND_DELETE_RECORDING';

    public static readonly PS_OPTION_LIVE_TV = 'PS_OPTION_LIVE_TV';

    public static readonly PS_OPTION_PLAY = 'PS_OPTION_PLAY';

    public static readonly PS_PREVIEW_FIRST_AIRED_DATE = 'PS_PREVIEW_FIRST_AIRED_DATE';

    public static readonly PS_PREVIEW_FIRST_AIRS_DATE = 'PS_PREVIEW_FIRST_AIRS_DATE';

    public static readonly PS_PREVIEW_STATUS_MSG_COMPLETE_REC =
        'PS_PREVIEW_STATUS_MSG_COMPLETE_REC';

    public static readonly PS_PREVIEW_STATUS_MSG_IN_PROGRESS_REC =
        'PS_PREVIEW_STATUS_MSG_IN_PROGRESS_REC';

    public static readonly PS_PREVIEW_STATUS_MSG_PARTIAL_REC = 'PS_PREVIEW_STATUS_MSG_PARTIAL_REC';

    public static readonly PS_PREVIEW_STATUS_MSG_SCHEDULED_AS_ONE_PASS =
        'PS_PREVIEW_STATUS_MSG_SCHEDULED_AS_ONE_PASS';

    public static readonly PS_PREVIEW_STATUS_MSG_SCHEDULED_AS_SINGLE_EXPLICIT =
        'PS_PREVIEW_STATUS_MSG_SCHEDULED_AS_SINGLE_EXPLICIT';

    public static readonly PS_PREVIEW_THUZZ_RATING_DULL = 'PS_PREVIEW_THUZZ_RATING_DULL';

    public static readonly PS_PREVIEW_THUZZ_RATING_GOOD = 'PS_PREVIEW_THUZZ_RATING_GOOD';

    public static readonly PS_PREVIEW_THUZZ_RATING_GREAT = 'PS_PREVIEW_THUZZ_RATING_GREAT';

    public static readonly PS_PREVIEW_THUZZ_RATING_OK = 'PS_PREVIEW_THUZZ_RATING_OK';

    public static readonly PS_PREVIEW_TRICKPLAY_RESTRICTION_ARE_NOT_ALLOWED =
        'PS_PREVIEW_TRICKPLAY_RESTRICTION_ARE_NOT_ALLOWED';

    public static readonly PS_PREVIEW_TRICKPLAY_RESTRICTION_ARE_NOT_SUPPORTED =
        'PS_PREVIEW_TRICKPLAY_RESTRICTION_ARE_NOT_SUPPORTED';

    public static readonly PS_PREVIEW_TRICKPLAY_RESTRICTION_IS_NOT_ALLOWED =
        'PS_PREVIEW_TRICKPLAY_RESTRICTION_IS_NOT_ALLOWED';

    public static readonly PS_PREVIEW_TRICKPLAY_RESTRICTION_IS_NOT_SUPPORTED =
        'PS_PREVIEW_TRICKPLAY_RESTRICTION_IS_NOT_SUPPORTED';

    public static readonly RACE = 'RACE';

    public static readonly RECORD_OVERLAY_OPTIONS_BOOKMARK_THIS_EPISODE =
        'RECORD_OVERLAY_OPTIONS_BOOKMARK_THIS_EPISODE';

    public static readonly RECORD_OVERLAY_OPTIONS_BOOKMARK_THIS_EVENT =
        'RECORD_OVERLAY_OPTIONS_BOOKMARK_THIS_EVENT';

    public static readonly RECORD_OVERLAY_OPTIONS_BOOKMARK_THIS_GAME =
        'RECORD_OVERLAY_OPTIONS_BOOKMARK_THIS_GAME';

    public static readonly RECORD_OVERLAY_OPTIONS_BOOKMARK_THIS_MATCH =
        'RECORD_OVERLAY_OPTIONS_BOOKMARK_THIS_MATCH';

    public static readonly RECORD_OVERLAY_OPTIONS_BOOKMARK_THIS_MOVIE =
        'RECORD_OVERLAY_OPTIONS_BOOKMARK_THIS_MOVIE';

    public static readonly RECORD_OVERLAY_OPTIONS_BOOKMARK_THIS_RACE =
        'RECORD_OVERLAY_OPTIONS_BOOKMARK_THIS_RACE';

    public static readonly RECORD_OVERLAY_OPTIONS_BOOKMARK_THIS_SHOW =
        'RECORD_OVERLAY_OPTIONS_BOOKMARK_THIS_SHOW';

    public static readonly RECORD_OVERLAY_OPTIONS_EPISODE = 'RECORD_OVERLAY_OPTIONS_EPISODE';

    public static readonly RECORD_OVERLAY_OPTIONS_EVENT = 'RECORD_OVERLAY_OPTIONS_EVENT';

    public static readonly RECORD_OVERLAY_OPTIONS_GAME = 'RECORD_OVERLAY_OPTIONS_GAME';

    public static readonly RECORD_OVERLAY_OPTIONS_MATCH = 'RECORD_OVERLAY_OPTIONS_MATCH';

    public static readonly RECORD_OVERLAY_OPTIONS_MOVIE = 'RECORD_OVERLAY_OPTIONS_MOVIE';

    public static readonly RECORD_OVERLAY_OPTIONS_RACE = 'RECORD_OVERLAY_OPTIONS_RACE';

    public static readonly RECORD_OVERLAY_OPTIONS_SHOW = 'RECORD_OVERLAY_OPTIONS_SHOW';

    public static readonly RECORD_OVERLAY_OPTION_MODIFY_RECORDING =
        'RECORD_OVERLAY_OPTION_MODIFY_RECORDING';

    public static readonly RECORD_OVERLAY_OPTION_CREATE_ONEPASS =
        'RECORD_OVERLAY_OPTION_CREATE_ONEPASS';

    public static readonly RECORD_OVERLAY_OPTION_MODIFY_ONEPASS =
        'RECORD_OVERLAY_OPTION_MODIFY_ONEPASS';

    public static readonly RECORD_OVERLAY_OPTION_RECORD_AGAIN =
        'RECORD_OVERLAY_OPTION_RECORD_AGAIN';

    public static readonly RECORD_OVERLAY_OPTION_WATCH_FROM_MY_SHOW =
        'RECORD_OVERLAY_OPTION_WATCH_FROM_MY_SHOW';

    public static readonly RECORD_OVERLAY_OPTION_BOOKMARK = 'RECORD_OVERLAY_OPTION_BOOKMARK';

    public static readonly RECORDING_OVERLAY_OPTION_CANCEL = 'RECORDING_OVERLAY_OPTION_CANCEL';

    public static readonly RECORDING_OVERLAY_OPTION_CANCEL_THIS =
        'RECORDING_OVERLAY_OPTION_CANCEL_THIS';

    public static readonly RECORDING_OVERLAY_OPTION_CANCEL_RECORDING =
        'RECORDING_OVERLAY_OPTION_CANCEL_RECORDING';

    public static readonly RECORDING_OVERLAY_OPTION_KEEP_UNTIL =
        'RECORDING_OVERLAY_OPTION_KEEP_UNTIL';

    public static readonly RECORDING_OVERLAY_OPTION_NO_CHANGE_IN_RECORDING_OPTION =
        'RECORDING_OVERLAY_OPTION_NO_CHANGE_IN_RECORDING_OPTION';

    public static readonly RECORDING_OVERLAY_OPTION_RECORD = 'RECORDING_OVERLAY_OPTION_RECORD';

    public static readonly RECORDING_OVERLAY_OPTION_RECORD_THIS =
        'RECORDING_OVERLAY_OPTION_RECORD_THIS';

    public static readonly RECORDING_OVERLAY_OPTION_THIS_EPISODE =
        'RECORDING_OVERLAY_OPTION_THIS_EPISODE';

    public static readonly RECORDING_OVERLAY_OPTION_THIS_EVENT =
        'RECORDING_OVERLAY_OPTION_THIS_EVENT';

    public static readonly RECORDING_OVERLAY_OPTION_THIS_GAME =
        'RECORDING_OVERLAY_OPTION_THIS_GAME';

    public static readonly RECORDING_OVERLAY_OPTION_THIS_MATCH =
        'RECORDING_OVERLAY_OPTION_THIS_MATCH';

    public static readonly RECORDING_OVERLAY_OPTION_THIS_MEET =
        'RECORDING_OVERLAY_OPTION_THIS_MEET';

    public static readonly RECORDING_OVERLAY_OPTION_THIS_MOVIE =
        'RECORDING_OVERLAY_OPTION_THIS_MOVIE';

    public static readonly RECORDING_OVERLAY_OPTION_THIS_RACE =
        'RECORDING_OVERLAY_OPTION_THIS_RACE';

    public static readonly RECORDING_OVERLAY_OPTION_THIS_RENT =
        'RECORDING_OVERLAY_OPTION_THIS_RENT';

    public static readonly RECORDING_OVERLAY_OPTION_THIS_SERIES =
        'RECORDING_OVERLAY_OPTION_THIS_SERIES';

    public static readonly RECORDING_OVERLAY_OPTION_THIS_SHOW =
        'RECORDING_OVERLAY_OPTION_THIS_SHOW';

    public static readonly RECORDING_OVERLAY_OPTION_THIS_SONG =
        'RECORDING_OVERLAY_OPTION_THIS_SONG';

    public static readonly RECORDING_OVERLAY_OPTION_THIS_WEB_VIDEO =
        'RECORDING_OVERLAY_OPTION_THIS_WEB_VIDEO';

    public static readonly RECORDING_OVERLAY_OPTION_START_RECORDING =
        'RECORDING_OVERLAY_OPTION_START_RECORDING';

    public static readonly RECORDING_OVERLAY_OPTION_STOP_RECORDING =
        'RECORDING_OVERLAY_OPTION_STOP_RECORDING';

    public static readonly RECORDING_OVERLAY_OPTION_STOP_RECORDING_AND_DELETE =
        'RECORDING_OVERLAY_OPTION_STOP_RECORDING_AND_DELETE';

    public static readonly RECORDING_OVERLAY_OPTION_TIME_AND_CHANNEL =
        'RECORDING_OVERLAY_OPTION_TIME_AND_CHANNEL';

    public static readonly RECORDING_OVERLAY_OPTION_TITLE = 'RECORDING_OVERLAY_OPTION_TITLE';

    public static readonly RECORDING_OVERLAY_OPTION_WITH_THESE_OPTIONS =
        'RECORDING_OVERLAY_OPTION_WITH_THESE_OPTIONS';

    public static readonly RECORDING_WHISPER_MESSAGE_FOR_EVENT_TYPE =
        'RECORDING_WHISPER_MESSAGE_FOR_EVENT_TYPE';

    public static readonly RECORDING_WHISPER_MESSAGE_FOR_EPISODE_TYPE =
        'RECORDING_WHISPER_MESSAGE_FOR_EPISODE_TYPE';

    public static readonly RECORDING_WHISPER_MESSAGE_FOR_GAME_TYPE =
        'RECORDING_WHISPER_MESSAGE_FOR_GAME_TYPE';

    public static readonly RECORDING_WHISPER_MESSAGE_FOR_MATCH_TYPE =
        'RECORDING_WHISPER_MESSAGE_FOR_MATCH_TYPE';

    public static readonly RECORDING_WHISPER_MESSAGE_FOR_MEET_TYPE =
        'RECORDING_WHISPER_MESSAGE_FOR_MATCH_TYPE';

    public static readonly RECORDING_WHISPER_MESSAGE_FOR_MOVIE_TYPE =
        'RECORDING_WHISPER_MESSAGE_FOR_MOVIE_TYPE';

    public static readonly RECORDING_WHISPER_MESSAGE_FOR_PROGRAM_TYPE =
        'RECORDING_WHISPER_MESSAGE_FOR_PROGRAM_TYPE';

    public static readonly RECORDING_WHISPER_MESSAGE_FOR_RACE_TYPE =
        'RECORDING_WHISPER_MESSAGE_FOR_RACE_TYPE';

    public static readonly RECORDING_WHISPER_MESSAGE_FOR_SHOW_TYPE =
        'RECORDING_WHISPER_MESSAGE_FOR_SHOW_TYPE';

    public static readonly RECORDINGS_DETAILS = 'RECORDINGS_DETAILS';

    public static readonly RECOVER_RECORDING_WHISPER_MESSAGE = 'RECOVER_RECORDING_WHISPER_MESSAGE';

    public static readonly RIGHT_PREVIEW_ELEMENT_CHANNEL = 'RIGHT_PREVIEW_ELEMENT_CHANNEL ';

    public static readonly RIGHT_PREVIEW_ELEMENT_GET_IN_HD = 'RIGHT_PREVIEW_ELEMENT_GET_IN_HD ';

    public static readonly RIGHT_PREVIEW_ELEMENT_INCLUDE = 'RIGHT_PREVIEW_ELEMENT_INCLUDE ';

    public static readonly RIGHT_PREVIEW_ELEMENT_KEEP_AT_MOST =
        'RIGHT_PREVIEW_ELEMENT_KEEP_AT_MOST ';

    public static readonly RIGHT_PREVIEW_ELEMENT_KEEP_UNTIL = 'RIGHT_PREVIEW_ELEMENT_KEEP_UNTIL ';

    public static readonly RIGHT_PREVIEW_ELEMENT_RECORD = 'RIGHT_PREVIEW_ELEMENT_RECORD ';

    public static readonly RIGHT_PREVIEW_ELEMENT_RENT_OR_BUY = 'RIGHT_PREVIEW_ELEMENT_RENT_OR_BUY ';

    public static readonly RIGHT_PREVIEW_ELEMENT_START_FROM = 'RIGHT_PREVIEW_ELEMENT_START_FROM ';

    public static readonly RIGHT_PREVIEW_ELEMENT_START_STOP = 'RIGHT_PREVIEW_ELEMENT_START_STOP ';

    public static readonly RIGHT_PREVIEW_ELEMENT_VIDEO_QUALITY =
        'RIGHT_PREVIEW_ELEMENT_VIDEO_QUALITY ';

    public static readonly RR_CHANNEL_RESTRICTION_MESSAGE = 'RR_CHANNEL_RESTRICTION_MESSAGE';

    public static readonly RR_COPYRIGHT_RESTRICTION_MESSAGE = 'RR_COPYRIGHT_RESTRICTION_MESSAGE';

    public static readonly RR_LIVE_TV_NOTIFICATION_MESSAGE = 'RR_LIVE_TV_NOTIFICATION_MESSAGE';

    public static readonly RR_LIVE_TV_CHANNEL_NOTIFICATION_MESSAGE =
        'RR_LIVE_TV_CHANNEL_NOTIFICATION_MESSAGE';

    public static readonly RR_NOT_AVAILABLE_TO_RECORD_MESSAGE =
        'RR_NOT_AVAILABLE_TO_RECORD_MESSAGE';

    public static readonly RR_NOT_AVAILABLE_TO_WATCH_OR_RECORD_MESSAGE =
        'RR_NOT_AVAILABLE_TO_WATCH_OR_RECORD_MESSAGE';

    public static readonly RR_RECORDING_NOT_PERMITTED_TEXT = 'RR_RECORDING_NOT_PERMITTED_TEXT';

    public static readonly RR_RECORDING_NOT_PERMITTED_TIP_TEXT =
        'RR_RECORDING_NOT_PERMITTED_TIP_TEXT';

    public static readonly SEASON = 'SEASON';

    public static readonly SEE_MORE_INFO = 'SEE_MORE_INFO';

    public static readonly SERIES = 'SERIES';

    public static readonly SETTINGS_ACCOUNT = 'SETTINGS_ACCOUNT';

    public static readonly SETTINGS_ACCOUNT_PREVIEW_TEXT = 'SETTINGS_ACCOUNT_PREVIEW_TEXT';

    public static readonly SETTINGS_ACCOUNT_SIGN_OUT_PREVIEW_TEXT =
        'SETTINGS_ACCOUNT_SIGN_OUT_PREVIEW_TEXT';

    public static readonly SETTINGS_ACCOUNT_RESET_PREVIEW_TEXT =
        'SETTINGS_ACCOUNT_RESET_PREVIEW_TEXT';

    public static readonly SETTINGS_APP_VERSION = 'SETTINGS_APP_VERSION';

    public static readonly SETTINGS_CA_DEVICE_ID = 'SETTINGS_CA_DEVICE_ID';

    public static readonly SETTINGS_CLEAR_TEXT = 'SETTINGS_CLEAR_TEXT';

    public static readonly SETTINGS_CONFIRM_APP_RESET = 'SETTINGS_CONFIRM_APP_RESET';

    public static readonly SETTINGS_CONFIRM_APP_SIGN_OUT = 'SETTINGS_CONFIRM_APP_SIGN_OUT';

    public static readonly SETTINGS_ENGLISH = 'SETTINGS_ENGLISH';

    public static readonly SETTINGS_HEADER_TITLE_DEFAULT = 'SETTINGS_HEADER_TITLE_DEFAULT';

    public static readonly SETTINGS_HEADER_TITLE_MENU_LANGUAGE =
        'SETTINGS_HEADER_TITLE_MENU_LANGUAGE';

    public static readonly SETTINGS_HEADER_TITLE_VIDEO_WINDOW =
        'SETTINGS_HEADER_TITLE_VIDEO_WINDOW';

    public static readonly SETTINGS_HEADER_TITLE_VIDEO_WINDOW_ACTIVE_PREVIEW =
        'SETTINGS_HEADER_TITLE_VIDEO_WINDOW_ACTIVE_PREVIEW';

    public static readonly SETTINGS_HEADER_TITLE_VIDEO_WINDOW_INACTIVE_PREVIEW =
        'SETTINGS_HEADER_TITLE_VIDEO_WINDOW_INACTIVE_PREVIEW';

    public static readonly SETTINGS_HELP = 'SETTINGS_HELP';

    public static readonly SETTINGS_HELP_DVR_SERVICE = 'SETTINGS_HELP_DVR_SERVICE';

    public static readonly SETTINGS_HELP_PC_FORGOTTEN_PIN = 'SETTINGS_HELP_PC_FORGOTTEN_PIN';

    public static readonly SETTINGS_HELP_PC_FORGOTTEN_PIN_PREVIEW_TEXT =
        'SETTINGS_HELP_PC_FORGOTTEN_PIN_PREVIEW_TEXT';

    public static readonly SETTINGS_HELP_PC_SETTINGS_LOCK_LIMITS =
        'SETTINGS_HELP_PC_SETTINGS_LOCK_LIMITS';

    public static readonly SETTINGS_HELP_PC_TURNING_ON_OFF = 'SETTINGS_HELP_PC_TURNING_ON_OFF';

    public static readonly SETTINGS_HELP_PREVIEW_TEXT = 'SETTINGS_HELP_PREVIEW_TEXT';

    public static readonly SETTINGS_HELP_PC_PREVIEW_TEXT = 'SETTINGS_HELP_PC_PREVIEW_TEXT';

    public static readonly SETTINGS_HELP_DVR_PREVIEW_TEXT = 'SETTINGS_HELP_DVR_PREVIEW_TEXT';

    public static readonly SETTINGS_INFO_TITLE = 'SETTINGS_INFO_TITLE';

    public static readonly SETTINGS_INFO_PREVIEW_TEXT = 'SETTINGS_INFO_PREVIEW_TEXT';

    public static readonly SETTINGS_MENU_LANGUAGE = 'SETTINGS_MENU_LANGUAGE';

    public static readonly SETTINGS_MENU_LANGUAGE_PREVIEW_TEXT =
        'SETTINGS_MENU_LANGUAGE_PREVIEW_TEXT';

    public static readonly SETTINGS_MENU_LANGUAGE_EN_PREVIEW_TEXT =
        'SETTINGS_MENU_LANGUAGE_EN_PREVIEW_TEXT';

    public static readonly SETTINGS_MENU_LANGUAGE_ES_PREVIEW_TEXT =
        'SETTINGS_MENU_LANGUAGE_ES_PREVIEW_TEXT';

    public static readonly SETTINGS_MENU_LANGUAGE_PAGE_DESCRIPTION =
        'SETTINGS_MENU_LANGUAGE_PAGE_DESCRIPTION';

    public static readonly SETTINGS_MY_SHOWS_OPTIONS = 'SETTINGS_MY_SHOWS_OPTIONS';

    public static readonly SETTINGS_MY_SHOWS_OPTIONS_PREVIEW_TEXT =
        'SETTINGS_MY_SHOWS_OPTIONS_PREVIEW_TEXT';

    public static readonly SETTINGS_MY_SHOWS_OPTIONS_SORT_BY_DATE =
        'SETTINGS_MY_SHOWS_OPTIONS_SORT_BY_DATE';

    public static readonly SETTINGS_MY_SHOWS_OPTIONS_SORT_BY_NAME =
        'SETTINGS_MY_SHOWS_OPTIONS_SORT_BY_NAME';

    public static readonly SETTINGS_MY_SHOWS_OPTIONS_CHOOSE_HOW_TO_VIEW_TEXT =
        'SETTINGS_MY_SHOWS_OPTIONS_CHOOSE_HOW_TO_VIEW_TEXT';

    public static readonly SETTINGS_ONEPASS_PREVIEW_TEXT = 'SETTINGS_ONEPASS_PREVIEW_TEXT';

    public static readonly SETTINGS_ONEPASS_TITLE_PREVIEW_TEXT =
        'SETTINGS_ONEPASS_TITLE_PREVIEW_TEXT';

    public static readonly SETTINGS_ONEPASS_RECORDING_OPTIONS =
        'SETTINGS_ONEPASS_RECORDING_OPTIONS';

    public static readonly SETTINGS_ONEPASS_RECORDING_OPTIONS_DESCRIPTION =
        'SETTINGS_ONEPASS_RECORDING_OPTIONS_DESCRIPTION';

    public static readonly SETTINGS_PC_ADULT_TEXT = 'SETTINGS_PC_ADULT_TEXT';

    public static readonly SETTINGS_PC_ALLOW_ALL_EXCEPT_ADULT_PREVIEW_TEXT =
        'SETTINGS_PC_ALLOW_ALL_EXCEPT_ADULT_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_ALLOW_ALL_EXCEPT_TEXT = 'SETTINGS_PC_ALLOW_ALL_EXCEPT_TEXT';

    public static readonly SETTINGS_PC_ALLOW_ALL_MOVIES_PREVIEW_TEXT =
        'SETTINGS_PC_ALLOW_ALL_MOVIES_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_ALLOW_ALL_TEXT = 'SETTINGS_PC_ALLOW_ALL_TEXT';

    public static readonly SETTINGS_PC_ALLOW_ALL_TV_SHOWS_PREVIEW_TEXT =
        'SETTINGS_PC_ALLOW_ALL_TV_SHOWS_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_BLOCK_ALL_MOVIES_PREVIEW_TEXT =
        'SETTINGS_PC_BLOCK_ALL_MOVIES_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_BLOCK_ALL_TEXT = 'SETTINGS_PC_BLOCK_ALL_TEXT';

    public static readonly SETTINGS_PC_BLOCK_ALL_TV_SHOWS_PREVIEW_TEXT =
        'SETTINGS_PC_BLOCK_ALL_TV_SHOWS_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_CHANGE_PIN_PREVIEW_TEXT =
        'SETTINGS_PC_CHANGE_PIN_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_CHANGE_PIN_TEXT = 'SETTINGS_PC_CHANGE_PIN_TEXT';

    public static readonly SETTINGS_PC_CHANGE_PIN_WHISPER_MESSAGE =
        'SETTINGS_PC_CHANGE_PIN_WHISPER_MESSAGE';

    public static readonly SETTINGS_PC_CURRENT_SETTING_TEXT = 'SETTINGS_PC_CURRENT_SETTING_TEXT';

    public static readonly SETTINGS_PC_CURRENT_SETTINGS_TEXT = 'SETTINGS_PC_CURRENT_SETTINGS_TEXT';

    public static readonly SETTINGS_PC_DISABLE_PARENTAL_CONTROLS_PREVIEW_TEXT =
        'SETTINGS_PC_DISABLE_PARENTAL_CONTROLS_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_DISABLE_PARENTAL_CONTROLS_TEXT =
        'SETTINGS_PC_DISABLE_PARENTAL_CONTROLS_TEXT';

    public static readonly SETTINGS_PC_DONT_HIDE_PREVIEW_TEXT =
        'SETTINGS_PC_DONT_HIDE_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_HIDE_ADULT_CONTENT_DESCRIPTION =
        'SETTINGS_PC_HIDE_ADULT_CONTENT_DESCRIPTION';

    public static readonly SETTINGS_PC_HIDE_ADULT_CONTENT_DONT_HIDE_TEXT =
        'SETTINGS_PC_HIDE_ADULT_CONTENT_DONT_HIDE_TEXT';

    public static readonly SETTINGS_PC_HIDE_ADULT_CONTENT_HEADER_TITLE_TEXT =
        'SETTINGS_PC_HIDE_ADULT_CONTENT_HEADER_TITLE_TEXT';

    public static readonly SETTINGS_PC_HIDE_ADULT_CONTENT_MAIN_PREVIEW_TEXT =
        'SETTINGS_PC_HIDE_ADULT_CONTENT_MAIN_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_HIDE_ADULT_CONTENT_ON_OFF_PREVIEW_TEXT =
        'SETTINGS_PC_HIDE_ADULT_CONTENT_ON_OFF_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_HIDE_ADULT_CONTENT_PREVIEW_TEXT =
        'SETTINGS_PC_HIDE_ADULT_CONTENT_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_HIDE_ADULT_COTENT_TEXT =
        'SETTINGS_PC_HIDE_ADULT_COTENT_TEXT';

    public static readonly SETTINGS_PC_HIGHEST_ALLOWED_MOVIE_RATING_TEXT =
        'SETTINGS_PC_HIGHEST_ALLOWED_MOVIE_RATING_TEXT';

    public static readonly SETTINGS_PC_HIGHEST_ALLOWED_RATING_NAME_TEXT =
        'SETTINGS_PC_HIGHEST_ALLOWED_RATING_NAME_TEXT';

    public static readonly SETTINGS_PC_HIGHEST_ALLOWED_RATING_PREVIEW_TEXT =
        'SETTINGS_PC_HIGHEST_ALLOWED_RATING_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_HIGHEST_ALLOWED_RATING_TEXT =
        'SETTINGS_PC_HIGHEST_ALLOWED_RATING_TEXT';

    public static readonly SETTINGS_PC_HIGHEST_ALLOWED_TV_RATING_TEXT =
        'SETTINGS_PC_HIGHEST_ALLOWED_TV_RATING_TEXT';

    public static readonly SETTINGS_PC_HIGHEST_MOVIE_RATING_PREVIEW_TEXT =
        'SETTINGS_PC_HIGHEST_MOVIE_RATING_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_HIGHEST_TV_RATING_PREVIEW_TEXT =
        'SETTINGS_PC_HIGHEST_TV_RATING_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_LOCKED_TEXT = 'SETTINGS_PC_LOCKED_TEXT';

    public static readonly SETTINGS_PC_OFF_TEXT = 'SETTINGS_PC_OFF_TEXT';

    public static readonly SETTINGS_PC_ON_TEXT = 'SETTINGS_PC_ON_TEXT';

    public static readonly SETTINGS_PC_PARENTAL_CONTROLS_LOCKED_PREVIEW_TEXT =
        'SETTINGS_PC_PARENTAL_CONTROLS_LOCKED_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_PARENTAL_CONTROLS_OFF_PREVIEW_TEXT =
        'SETTINGS_PC_PARENTAL_CONTROLS_OFF_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_PARENTAL_CONTROLS_TEXT =
        'SETTINGS_PC_PARENTAL_CONTROLS_TEXT';

    public static readonly SETTINGS_PC_PARENTAL_CONTROLS_UNLOCKED_FIRST_PREVIEW_TEXT =
        'SETTINGS_PC_PARENTAL_CONTROLS_UNLOCKED_FIRST_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_PARENTAL_CONTROLS_UNLOCKED_SECOND_PREVIEW_TEXT =
        'SETTINGS_PC_PARENTAL_CONTROLS_UNLOCKED_SECOND_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_PREVIEW_TEXT = 'SETTINGS_PC_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_SET_RATING_LIMITS_ALLOW_ALL_PREVIEW_TEXT =
        'SETTINGS_PC_SET_RATING_LIMITS_ALLOW_ALL_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_SET_RATING_LIMITS_ALLOWED_PREVIEW_TEXT =
        'SETTINGS_PC_SET_RATING_LIMITS_ALLOWED_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_SET_RATING_LIMITS_BLOCKED_PREVIEW_TEXT =
        'SETTINGS_PC_SET_RATING_LIMITS_BLOCKED_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_SET_RATING_LIMITS_DESCRIPTION =
        'SETTINGS_PC_SET_RATING_LIMITS_DESCRIPTION';

    public static readonly SETTINGS_PC_SET_RATING_LIMITS_HEADER_TITLE_TEXT =
        'SETTINGS_PC_SET_RATING_LIMITS_HEADER_TITLE_TEXT';

    public static readonly SETTINGS_PC_SET_RATING_LIMITS_NONE_PREVIEW_TEXT =
        'SETTINGS_PC_SET_RATING_LIMITS_NONE_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_SET_RATING_LIMITS_PREVIEW_TEXT =
        'SETTINGS_PC_SET_RATING_LIMITS_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_SET_RATING_LIMITS_TEXT =
        'SETTINGS_PC_SET_RATING_LIMITS_TEXT';

    public static readonly SETTINGS_PC_HEADER_TITLE_TEXT = 'SETTINGS_PC_HEADER_TITLE_TEXT';

    public static readonly SETTINGS_PC_UNLOCKED_TEXT = 'SETTINGS_PC_UNLOCKED_TEXT';

    public static readonly SETTINGS_PC_UNRATED_MOVIES_NOTE_TEXT =
        'SETTINGS_PC_UNRATED_MOVIES_NOTE_TEXT';

    public static readonly SETTINGS_PC_UNRATED_MOVIES_TEXT = 'SETTINGS_PC_UNRATED_MOVIES_TEXT';

    public static readonly SETTINGS_PC_UNRATED_ALLOW_ALL_GENERIC_PREVIEW_TEXT =
        'SETTINGS_PC_UNRATED_ALLOW_ALL_GENERIC_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_UNRATED_BLOCK_ALL_GENERIC_PREVIEW_TEXT =
        'SETTINGS_PC_UNRATED_BLOCK_ALL_GENERIC_PREVIEW_TEXT';

    public static readonly SETTINGS_PC_UNRATED_RATING_NAME_TEXT =
        'SETTINGS_PC_UNRATED_RATING_NAME_TEXT';

    public static readonly SETTINGS_PC_UNRATED_SHOWS_AND_MOVIES_TEXT =
        'SETTINGS_PC_UNRATED_SHOWS_AND_MOVIES_TEXT';

    public static readonly SETTINGS_PC_UNRATED_TV_SHOWS_TEXT = 'SETTINGS_PC_UNRATED_TV_SHOWS_TEXT';

    public static readonly SETTINGS_PC_UNRATED_TV_TEXT = 'SETTINGS_PC_UNRATED_TV_TEXT';

    public static readonly SETTINGS_PRIVACY_POLICY = 'SETTINGS_PRIVACY_POLICY';

    public static readonly SETTINGS_RESET_APP = 'SETTINGS_RESET_APP';

    public static readonly SETTINGS_RESET_TEXT = 'SETTINGS_RESET_TEXT';

    public static readonly SETTINGS_RESET_TO_DEFAULT_TEXT = 'SETTINGS_RESET_TO_DEFAULT_TEXT';

    public static readonly SETTINGS_SHELL_APP_VERSION = 'SETTINGS_SHELL_APP_VERSION';

    public static readonly SETTINGS_SIGN_OUT = 'SETTINGS_SIGN_OUT';

    public static readonly SETTINGS_SIGN_OUT_APP_EXIT_TEXT = 'SETTINGS_SIGN_OUT_APP_EXIT_TEXT';

    public static readonly SETTINGS_SIGN_OUT_ERROR = 'SETTINGS_SIGN_OUT_ERROR';

    public static readonly SETTINGS_SIGN_OUT_ERROR_TEXT = 'SETTINGS_SIGN_OUT_ERROR_TEXT';

    public static readonly SETTINGS_SIGN_OUT_NETWORK_ERROR_TEXT =
        'SETTINGS_SIGN_OUT_NETWORK_ERROR_TEXT';

    public static readonly SETTINGS_SIGN_OUT_OF = 'SETTINGS_SIGN_OUT_OF';

    public static readonly SETTINGS_SIGN_OUT_SERVICE_ERROR_TEXT =
        'SETTINGS_SIGN_OUT_SERVICE_ERROR_TEXT';

    public static readonly SETTINGS_SIGN_OUT_SPINNER_MESSAGE = 'SETTINGS_SIGN_OUT_SPINNER_MESSAGE';

    public static readonly SETTINGS_SPANISH = 'SETTINGS_SPANISH';

    public static readonly SETTINGS_SUPPORT = 'SETTINGS_SUPPORT';

    public static readonly SETTINGS_TIVO_SERVICE_NUMBER = 'SETTINGS_TIVO_SERVICE_NUMBER';

    public static readonly SETTINGS_USER_PREFERENCES = 'SETTINGS_USER_PREFERENCES';

    public static readonly SETTINGS_USER_PREFERENCES_PREVIEW = 'SETTINGS_USER_PREFERENCES_PREVIEW';

    public static readonly SETTINGS_USER_PREFERENCES_TITLE = 'SETTINGS_USER_PREFERENCES_TITLE';

    public static readonly SETTINGS_USER_PREFERENCES_VIDEO_WINDOW_PREVIEW_TEXT =
        'SETTINGS_USER_PREFERENCES_VIDEO_WINDOW_PREVIEW_TEXT';

    public static readonly SETTINGS_VIDEO_WINDOW = 'SETTINGS_VIDEO_WINDOW';

    public static readonly SETTINGS_VIDEO_WINDOW_OPTION_NO = 'SETTINGS_VIDEO_WINDOW_OPTION_NO';

    public static readonly SETTINGS_VIDEO_WINDOW_OPTION_YES = 'SETTINGS_VIDEO_WINDOW_OPTION_YES';

    public static readonly SETTINGS_VIDEO_WINDOW_PAGE_DESCRIPTION =
        'SETTINGS_VIDEO_WINDOW_PAGE_DESCRIPTION';

    public static readonly SIDEBAR_NAVIGATION_MENU_GUIDE_OPTION_TEXT =
        'SIDEBAR_NAVIGATION_MENU_GUIDE_OPTION_TEXT';

    public static readonly SIDEBAR_NAVIGATION_MENU_MY_SHOWS_OPTION_TEXT =
        'SIDEBAR_NAVIGATION_MENU_MY_SHOWS_OPTION_TEXT';

    public static readonly SIDEBAR_NAVIGATION_MENU_SETTINGS_OPTION_TEXT =
        'SIDEBAR_NAVIGATION_MENU_SETTINGS_OPTION_TEXT';

    public static readonly SIDEBAR_NAVIGATION_MENU_ON_DEMAND_OPTION_TEXT =
        'SIDEBAR_NAVIGATION_MENU_ON_DEMAND_OPTION_TEXT';

    public static readonly SIGN_IN_ACCOUNT_LOCKED_DESCRIPTION =
        'SIGN_IN_ACCOUNT_LOCKED_DESCRIPTION';

    public static readonly SIGN_IN_AND_ENTER = 'SIGN_IN_AND_ENTER';

    public static readonly SIGN_IN_CODE_EXPIRED_MESSAGE = 'SIGN_IN_CODE_EXPIRED_MESSAGE';

    public static readonly SIGN_IN_ERROR_ACCOUNT_LOCKED_TITLE =
        'SIGN_IN_ERROR_ACCOUNT_LOCKED_TITLE';

    public static readonly SIGN_IN_ERROR_OVERLAY_DESCRIPTION = 'SIGN_IN_ERROR_OVERLAY_DESCRIPTION';

    public static readonly SIGN_IN_ERROR_OVERLAY_TITLE = 'SIGN_IN_ERROR_OVERLAY_TITLE';

    public static readonly SIGN_IN_ERROR_TOO_MANY_DEVICES_TITLE =
        'SIGN_IN_ERROR_TOO_MANY_DEVICES_TITLE';

    public static readonly SIGN_IN_GO_TO = 'SIGN_IN_GO_TO';

    public static readonly SIGN_IN_NEW_ACTIVATION_BUTTON_LABEL =
        'SIGN_IN_NEW_ACTIVATION_BUTTON_LABEL';

    public static readonly SIGN_IN_REFRESH_MESSAGE = 'SIGN_IN_REFRESH_MESSAGE';

    public static readonly SIGN_IN_SPINNER_MESSAGE = 'SIGN_IN_SPINNER_MESSAGE';

    public static readonly SIGN_IN_TO = 'SIGN_IN_TO';

    public static readonly SIGN_IN_TOO_MANY_DEVICES_DESCRIPTION =
        'SIGN_IN_TOO_MANY_DEVICES_DESCRIPTION';

    public static readonly SLO_BODY = 'SLO_BODY';

    public static readonly SLO_OPTION_CANCEL = 'SLO_OPTION_CANCEL';

    public static readonly SLO_OPTION_LEARN_MORE = 'SLO_OPTION_LEARN_MORE';

    public static readonly SLO_OPTION_OK = 'SLO_OPTION_OK';

    public static readonly SLO_TITLE = 'SLO_TITLE';

    public static readonly SHOW = 'SHOW';

    public static readonly SOCU_ERROR_OVERLAY_DESCRIPTION = 'SOCU_ERROR_OVERLAY_DESCRIPTION';

    public static readonly SOCU_ERROR_OVERLAY_TITLE = 'SOCU_ERROR_OVERLAY_TITLE';

    public static readonly SOMETHING_WENT_WRONG_WHISPER_DESCRIPTION =
        'SOMETHING_WENT_WRONG_WHISPER_DESCRIPTION';

    public static readonly SORTED_BY_DATE = 'SORTED_BY_DATE';

    public static readonly SORTED_BY_NAME = 'SORTED_BY_NAME';

    public static readonly SORTED_BY_SEASON = 'SORTED_BY_SEASON';

    public static readonly SOS_OVERLAY_DESCRIPTION = 'SOS_OVERLAY_DESCRIPTION';

    public static readonly SOS_OVERLAY_OPTION_EXIT = 'SOS_OVERLAY_OPTION_EXIT';

    public static readonly SOS_OVERLAY_TITLE = 'SOS_OVERLAY_TITLE';

    public static readonly SPORT = 'SPORT';

    public static readonly STREAMING_OPTIONS_OVERLAY_ENTITLEMENT_SUBSCRIBABLE =
        'STREAMING_OPTIONS_OVERLAY_ENTITLEMENT_SUBSCRIBABLE';

    public static readonly STREAMING_OPTIONS_OVERLAY_ENTITLEMENT_SUBSCRIBED =
        'STREAMING_OPTIONS_OVERLAY_ENTITLEMENT_SUBSCRIBED';

    public static readonly STREAMING_OPTIONS_OVERLAY_TITLE = 'STREAMING_OPTIONS_OVERLAY_TITLE';

    public static readonly SUBTITLE_OVERLAY_TITLE = 'SUBTITLE_OVERLAY_TITLE';

    public static readonly STOP_RECORDING_OVERLAY_DESCRIPTION =
        'STOP_RECORDING_OVERLAY_DESCRIPTION';

    public static readonly STOP_RECORDING_OVERLAY_DESCRIPTION_THIS =
        'STOP_RECORDING_OVERLAY_DESCRIPTION_THIS';

    public static readonly LIVE_TV_STREAM_STATS = 'LIVE_TV_STREAM_STATS';

    public static readonly TEMPORARY_SERVICE_CONNECTION_ISSUE_DESCRIPTION =
        'TEMPORARY_SERVICE_CONNECTION_ISSUE_DESCRIPTION';

    public static readonly TEMPORARY_SERVICE_CONNECTION_ISSUE_TITLE =
        'TEMPORARY_SERVICE_CONNECTION_ISSUE_TITLE';

    public static readonly TITLE_NOT_AVAILABLE = 'TITLE_NOT_AVAILABLE';

    public static readonly TRICKPLAY_AND_TEXT = 'TRICKPLAY_AND_TEXT';

    public static readonly TRICKPLAY_FAST_FORWARD = 'TRICKPLAY_FAST_FORWARD';

    public static readonly TRICKPLAY_PAUSE = 'TRICKPLAY_PAUSE';

    public static readonly TRICKPLAY_REWIND = 'TRICKPLAY_REWIND';

    public static readonly TRICKPLAY_UNKNOWN = 'TRICKPLAY_UNKNOWN';

    public static readonly VIEW_ALL_TEXT = 'VIEW_ALL_TEXT';

    public static readonly VOD_BROWSE_ERROR_OVERLAY_DESCRIPTION =
        'VOD_BROWSE_ERROR_OVERLAY_DESCRIPTION';

    public static readonly VOD_BROWSE_ERROR_OVERLAY_TITLE = 'VOD_BROWSE_ERROR_OVERLAY_TITLE';

    public static readonly VOD_AVAILABILITY_TODAY_SUBSTITUTION =
        'VOD_AVAILABILITY_TODAY_SUBSTITUTION';

    public static readonly VOD_AVAILABILITY_TOMORROW_SUBSTITUTION =
        'VOD_AVAILABILITY_TOMORROW_SUBSTITUTION';

    public static readonly VOD_AVAILABILITY_UNTIL_SUBSTITUTION =
        'VOD_AVAILABILITY_UNTIL_SUBSTITUTION';

    public static readonly VOD_ENTITLEMENT_FREE_TEXT = 'VOD_ENTITLEMENT_FREE_TEXT';

    public static readonly VOD_ENTITLEMENT_INCLUDED_WITH_YOUR_SUBSCRIPTION =
        'VOD_ENTITLEMENT_INCLUDED_WITH_YOUR_SUBSCRIPTION';

    public static readonly VOD_ENTITLEMENT_NOT_AVAILABLE_FOR_PURCHASE =
        'VOD_ENTITLEMENT_NOT_AVAILABLE_FOR_PURCHASE';

    public static readonly VOD_ENTITLEMENT_UPGRADE_TO_WATCH = 'VOD_ENTITLEMENT_UPGRADE_TO_WATCH';

    public static readonly VOD_FORMAT_SELECTOR_AVAILABILITY_TODAY =
        'VOD_FORMAT_SELECTOR_AVAILABILITY_TODAY';

    public static readonly VOD_FORMAT_SELECTOR_AVAILABILITY_TOMORROW =
        'VOD_FORMAT_SELECTOR_AVAILABILITY_TOMORROW';

    public static readonly VOD_FORMAT_SELECTOR_AVAILABILITY_DATE =
        'VOD_FORMAT_SELECTOR_AVAILABILITY_DATE';

    public static readonly VOD_FORMAT_SELECTOR_RENTAL_AVAILABILITY_TODAY =
        'VOD_FORMAT_SELECTOR_RENTAL_AVAILABILITY_TODAY';

    public static readonly VOD_FORMAT_SELECTOR_RENTAL_AVAILABILITY_TOMORROW =
        'VOD_FORMAT_SELECTOR_RENTAL_AVAILABILITY_TOMORROW';

    public static readonly VOD_FORMAT_SELECTOR_RENTAL_AVAILABILITY_DATE =
        'VOD_FORMAT_SELECTOR_RENTAL_AVAILABILITY_DATE';

    public static readonly VOD_FORMAT_SELECTOR_RENTED = 'VOD_FORMAT_SELECTOR_RENTED';

    public static readonly VOD_FORMAT_SELECTOR_FREE = 'VOD_FORMAT_SELECTOR_FREE';

    public static readonly VOD_FORMAT_SELECTOR_INCLUDED_WITH_SUBSCRIPTION =
        'VOD_FORMAT_SELECTOR_INCLUDED_WITH_SUBSCRIPTION';

    public static readonly VOD_FORMAT_SELECTOR_UPGRADE_TO_WATCH =
        'VOD_FORMAT_SELECTOR_UPGRADE_TO_WATCH';

    public static readonly VOD_FORMAT_SELECTOR_NOT_AVAILABLE_FOR_PURCHASE =
        'VOD_FORMAT_SELECTOR_NOT_AVAILABLE_FOR_PURCHASE';

    public static readonly VOD_FORMAT_SELECTOR_WITH_DURATION = 'VOD_FORMAT_SELECTOR_WITH_DURATION';

    public static readonly VOD_PREVIEW_CURRENT = 'VOD_PREVIEW_CURRENT';

    public static readonly VOD_PREVIEW_TRICKPLAY_FAST_FORWARD =
        'VOD_PREVIEW_TRICKPLAY_FAST_FORWARD';

    public static readonly VOD_PREVIEW_TRICKPLAY_NOT_ALLOWED_TEXT =
        'VOD_PREVIEW_TRICKPLAY_NOT_ALLOWED_TEXT';

    public static readonly VOD_PREVIEW_TRICKPLAY_AND_TEXT = 'VOD_PREVIEW_TRICKPLAY_AND_TEXT';

    public static readonly VOD_PREVIEW_TRICKPLAY_IS_NOT_ALLOWED_TEXT =
        'VOD_PREVIEW_TRICKPLAY_IS_NOT_ALLOWED_TEXT';

    public static readonly VOD_PREVIEW_TRICKPLAY_PAUSE = 'VOD_PREVIEW_TRICKPLAY_PAUSE';

    public static readonly VOD_PREVIEW_TRICKPLAY_REWIND = 'VOD_PREVIEW_TRICKPLAY_REWIND';

    public static readonly VOD_OVERLAY_CANNOT_RENT = 'VOD_OVERLAY_CANNOT_RENT';

    public static readonly VOD_OVERLAY_PURCHASE_FAILED_TITLE = 'VOD_OVERLAY_PURCHASE_FAILED_TITLE';

    public static readonly VOD_OVERLAY_PURCHASE_FAILED_DESCRIPTION =
        'VOD_OVERLAY_PURCHASE_FAILED_DESCRIPTION';

    public static readonly VOD_OVERLAY_RENTAL_NOT_ALLOWED = 'VOD_OVERLAY_RENTAL_NOT_ALLOWED';

    public static readonly VOD_OVERLAY_SUBSCRIPTION_REQUIRED = 'VOD_OVERLAY_SUBSCRIPTION_REQUIRED';

    public static readonly VOD_OVERLAY_SUBSCRIPTION_REQUIRED_WITH_URL =
        'VOD_OVERLAY_SUBSCRIPTION_REQUIRED_WITH_URL';

    public static readonly VOD_PLAY_ACTION_SHOW_UNAVAILABLE_TITLE =
        'VOD_PLAY_ACTION_SHOW_UNAVAILABLE_TITLE';

    public static readonly VOD_PLAY_ACTION_SHOW_UNAVAILABLE_DESCRIPTION =
        'VOD_PLAY_ACTION_SHOW_UNAVAILABLE_DESCRIPTION';

    public static readonly WATCH_LIST_DETAILS = 'WATCH_LIST_DETAILS';

    public static readonly WHISPER_EPISODE_UNAVAILABLE = 'WHISPER_EPISODE_UNAVAILABLE';

    public static readonly WHISPER_SCREEN_DETAILS_UNAVAILABLE =
        'WHISPER_SCREEN_DETAILS_UNAVAILABLE';

    public static readonly WILL_NOT_RECORD = 'WILL_NOT_RECORD';

    public static readonly YEAR = 'YEAR';

    public static readonly GUIDE_MESSAGE = 'GUIDE_MESSAGE';

    public static readonly PRESS_BACK_TO_GO_TO_FULL_GUIDE = 'PRESS_BACK_TO_GO_TO_FULL_GUIDE';

    public static readonly EMPTY_FILTERED_GUIDE_NO_SHOWS_MESSAGE =
        'EMPTY_FILTERED_GUIDE_NO_SHOWS_MESSAGE';

    public static readonly EMPTY_FILTERED_GUIDE_ACTION_CHANGE_FILTERS =
        'EMPTY_FILTERED_GUIDE_ACTION_CHANGE_FILTERS';

    public static readonly JUMP_CHANNELS_CURRENTLY_UNSUPPORTED =
        'JUMP_CHANNELS_CURRENTLY_UNSUPPORTED';

    public static readonly PPV_CHANNELS_CURRENTLY_UNSUPPORTED =
        'PPV_CHANNELS_CURRENTLY_UNSUPPORTED';

    public static readonly FOUR_K_CHANNELS_CURRENTLY_UNSUPPORTED =
        'FOUR_K_CHANNELS_CURRENTLY_UNSUPPORTED';

    public static readonly TODO_LIST_TITLE = 'TODO_LIST_TITLE';

    public static readonly TODO_LIST_PREVIEW_TEXT = 'TODO_LIST_PREVIEW_TEXT';

    public static readonly RECORDING_ACTIVITY_TITLE = 'RECORDING_ACTIVITY_TITLE';

    public static readonly RECORDING_ACTIVITY_PREVIEW_TEXT = 'RECORDING_ACTIVITY_PREVIEW_TEXT';

    public static readonly TODO_LIST_PAGE_HEADER_TITLE = 'TODO_LIST_PAGE_HEADER_TITLE';

    public static readonly EMPTY_TODO_LIST_MESSAGE = 'EMPTY_TODO_LIST_MESSAGE';

    public static readonly RECORDING_DIFFERENT_SHOWING_TITLE = 'RECORDING_DIFFERENT_SHOWING_TITLE';

    public static readonly RECORDING_DIFFERENT_SHOWING_PREVIEW =
        'RECORDING_DIFFERENT_SHOWING_PREVIEW';

    public static readonly RECORDING_DIFFERENT_SHOWING_BODY = 'RECORDING_DIFFERENT_SHOWING_BODY';

    public static readonly NOT_AUTHORIZED_TITLE = 'NOT_AUTHORIZED_TITLE';

    public static readonly NOT_AUTHORIZED_PREVIEW = 'NOT_AUTHORIZED_PREVIEW';

    public static readonly NOT_AUTHORIZED_BODY = 'NOT_AUTHORIZED_BODY';

    public static readonly NOT_FIRST_RUN_TITLE = 'NOT_FIRST_RUN_TITLE';

    public static readonly NOT_FIRST_RUN_PREVIEW = 'NOT_FIRST_RUN_PREVIEW';

    public static readonly NOT_FIRST_RUN_BODY = 'NOT_FIRST_RUN_BODY';

    public static readonly RESOLUTION_TOO_LOW_TITLE = 'RESOLUTION_TOO_LOW_TITLE';

    public static readonly RESOLUTION_TOO_LOW_PREVIEW = 'RESOLUTION_TOO_LOW_PREVIEW';

    public static readonly RESOLUTION_TOO_LOW_BODY = 'RESOLUTION_TOO_LOW_BODY';

    public static readonly NOT_RECORDED_STORAGE_QUOTA_TITLE = 'NOT_RECORDED_STORAGE_QUOTA_TITLE';

    public static readonly NOT_RECORDED_STORAGE_QUOTA_PREVIEW =
        'NOT_RECORDED_STORAGE_QUOTA_PREVIEW';

    public static readonly NOT_RECORDED_STORAGE_QUOTA_BODY = 'NOT_RECORDED_STORAGE_QUOTA_BODY';

    public static readonly NOT_RECORDED_KEEP_AT_MOST_TITLE = 'NOT_RECORDED_KEEP_AT_MOST_TITLE';

    public static readonly NOT_RECORDED_KEEP_AT_MOST_PREVIEW = 'NOT_RECORDED_KEEP_AT_MOST_PREVIEW';

    public static readonly NOT_RECORDED_KEEP_AT_MOST_BODY = 'NOT_RECORDED_KEEP_AT_MOST_BODY';

    public static readonly GENERIC_UNKNOWN_TITLE = 'GENERIC_UNKNOWN_TITLE';

    public static readonly GENERIC_UNKNOWN_PREVIEW = 'GENERIC_UNKNOWN_PREVIEW';

    public static readonly GENERIC_UNKNOWN_BODY = 'GENERIC_UNKNOWN_BODY';

    public static readonly EPISODE_PLURAL = 'EPISODE_PLURAL';

    public static readonly EPISODE_WITH_ARTICLE = 'EPISODE_WITH_ARTICLE';

    public static readonly EVENT_PLURAL = 'EVENT_PLURAL';

    public static readonly EVENT_WITH_ARTICLE = 'EVENT_WITH_ARTICLE';

    public static readonly GAME_PLURAL = 'GAME_PLURAL';

    public static readonly GAME_WITH_ARTICLE = 'GAME_WITH_ARTICLE';

    public static readonly RACE_PLURAL = 'RACE_PLURAL';

    public static readonly RACE_WITH_ARTICLE = 'RACE_WITH_ARTICLE';

    public static readonly SHOW_PLURAL = 'SHOW_PLURAL';

    public static readonly SHOW_WITH_ARTICLE = 'SHOW_WITH_ARTICLE';

    public static readonly MOVIE_PLURAL = 'MOVIE_PLURAL';

    public static readonly MOVIE_WITH_ARTICLE = 'MOVIE_WITH_ARTICLE';

    public static readonly MATCH_PLURAL = 'MATCH_PLURAL';

    public static readonly MATCH_WITH_ARTICLE = 'MATCH_WITH_ARTICLE';

    public static readonly EMPTY_RECORDING_ACTIVITY_MESSAGE_FIRST_PART =
        'EMPTY_RECORDING_ACTIVITY_MESSAGE_FIRST_PART';

    public static readonly EMPTY_RECORDING_ACTIVITY_MESSAGE_SECOND_PART =
        'EMPTY_RECORDING_ACTIVITY_MESSAGE_SECOND_PART';

    public static readonly RECORDING_ACTIVITY_REASON_CANCELED =
        'RECORDING_ACTIVITY_REASON_CANCELED';

    public static readonly RECORDING_ACTIVITY_REASON_CAN_RECOVER =
        'RECORDING_ACTIVITY_REASON_CAN_RECOVER';

    public static readonly RECORDING_ACTIVITY_REASON_DELETED = 'RECORDING_ACTIVITY_REASON_DELETED';

    public static readonly RECORDING_ACTIVITY_REASON_DUPLICATE =
        'RECORDING_ACTIVITY_REASON_DUPLICATE';

    public static readonly RECORDING_ACTIVITY_REASON_LIMIT_REACHED =
        'RECORDING_ACTIVITY_REASON_LIMIT_REACHED';

    public static readonly RECORDING_ACTIVITY_REASON_NOT_AVAILABLE =
        'RECORDING_ACTIVITY_REASON_NOT_AVAILABLE';

    public static readonly RECORDING_ACTIVITY_REASON_NOT_NEW = 'RECORDING_ACTIVITY_REASON_NOT_NEW';

    public static readonly RECORDING_ACTIVITY_REASON_NOT_RECORDED =
        'RECORDING_ACTIVITY_REASON_NOT_RECORDED';

    public static readonly RECORDING_ACTIVITY_REASON_QUOTA_LIMITS =
        'RECORDING_ACTIVITY_REASON_QUOTA_LIMITS';

    public static readonly TODO_SCREEN_WHISPER_MESSAGE = 'TODO_SCREEN_WHISPER_MESSAGE';

    public static readonly RECORDING_ACTIVITY_GO_TO_RECOVER = 'RECORDING_ACTIVITY_GO_TO_RECOVER';

    public static readonly RECORDING_ACTIVITY_SCREEN_WHISPER_MESSAGE =
        'RECORDING_ACTIVITY_SCREEN_WHISPER_MESSAGE';

    public static readonly RECORDING_ACTIVITY_DIFFERENT_SHOWING_BODY =
        'RECORDING_ACTIVITY_DIFFERENT_SHOWING_BODY';

    public static readonly RECORDING_ACTIVITY_DIFFERENT_SHOWING_TITLE =
        'RECORDING_ACTIVITY_DIFFERENT_SHOWING_TITLE';

    public static readonly RECORDING_ACTIVITY_DIFFERENT_SHOWING_PREVIEW =
        'RECORDING_ACTIVITY_DIFFERENT_SHOWING_PREVIEW';

    public static readonly NOT_AUTHORIZED_RECORDING_ACTIVITY_TITLE =
        'NOT_AUTHORIZED_RECORDING_ACTIVITY_TITLE';

    public static readonly NOT_AUTHORIZED_RECORDING_ACTIVITY_PREVIEW =
        'NOT_AUTHORIZED_RECORDING_ACTIVITY_PREVIEW';

    public static readonly NOT_AUTHORIZED_RECORDING_ACTIVITY_BODY =
        'NOT_AUTHORIZED_RECORDING_ACTIVITY_BODY';

    public static readonly GENERIC_UNKNOWN_RECORDING_ACTIVITY_BODY =
        'GENERIC_UNKNOWN_RECORDING_ACTIVITY_BODY';

    public static readonly GENERIC_UNKNOWN_RECORDING_ACTIVITY_PREVIEW =
        'GENERIC_UNKNOWN_RECORDING_ACTIVITY_PREVIEW';

    public static readonly GENERIC_UNKNOWN_RECORDING_ACTIVITY_TITLE =
        'GENERIC_UNKNOWN_RECORDING_ACTIVITY_TITLE';

    public static readonly RECORDING_FOOTER_PRESS_AND_HOLD_MESSAGE =
        'RECORDING_FOOTER_PRESS_AND_HOLD_MESSAGE';
}
